<template>
    <div class="share_account_container" v-show="showShareDialog" style="display:none">
        <div class="share_account_dialog"
        @click.stop=""
        :style="{width:dialogWidth+'px'}"
        v-loading="isLoadingTdk">
            <div class="swithBtn" v-if="isTDKstep&&!has_new_video_tts&& optionType!=2&&optionType!=3">
                <el-switch
                    active-color="#85ce61"
                    v-model="advancedSwitch"
                    :active-text="advancedSwitch?'高级模式已开启':'高级模式已关闭'"
                >
                </el-switch>
            </div>
            <div class="share_account_header" v-show="cropperShowing">
                <h3 class="dialog_title">示例 GIF 截取</h3>
                <span class="dialog_title_tips dialog_title_tips--dim">(截取视频帧生成播放示例 GIF 动图，只需拖动滑块截取连续 3 秒生成 GIF 动图; 为保证效果请不要截取片头/片尾及片段转场的时间段。)</span>
                <i class="iconfont icon-close" @click="closeDialog"></i>
            </div>
            <div class="share_account_header" v-show="!cropperShowing">
                <h3 class="dialog_title" v-show="!previewVisible" v-text="dialog_title"></h3>
                <h3 class="dialog_title" v-show="previewVisible">分享预览</h3>
                <span class="dialog_title_tips" v-show="!firstStep && optionType==1 && !isTDKstep &&!hasNoAccount">(为提高分享到海外社媒平台视频的曝光度，系统将智能推荐分享时间；如有特殊需要，可自定义修改)</span>
                <span class="dialog_title_tips" v-show="isTDKstep&&!previewVisible">(TDK会影响视频流量，请务必填写)</span>
                <span class="dialog_title_tips dialog_title_tips--dim" v-show="!firstStep &&!isTDKstep && optionType==2">(支持选择同一栏目下多个分类)</span>
                <i class="iconfont icon-close" @click="closeDialog"></i>
            </div>
            <div class="share_account_body" :class="{'share_account_body--scroll':!firstStep && optionType==2}" v-show="!isTDKstep">
                <div v-show="firstStep">
                    <p style="margin-bottom:40px">选择你要分享的渠道:</p>
                    <div class="share_account_body_top">
                        <div class="account_body_top_name" @click="waynextStep(1)" v-if="userMeal && userMeal[10].lower[32].value != 3 && (isShow_cms_option || siteList.length)">
                            <div class="account_body_img">
                                <img src="/assets/imgs/allweyes.png">
                            </div>
                            <span>全网通</span>
                        </div>
                        <div
                          v-if="isOpenWebsite && origin!=='moveHouse'"
                          class="account_body_top_name"
                          @click="waynextStep(2)"
                        >
                            <div class="account_body_img">
                                <img src="/assets/imgs/videocall.png">
                            </div>
                            <span>视频官网</span>
                        </div>
                        <div class="account_body_top_name" @click="waynextStep(3)" v-if="hasSocialMedia && fishSocialAccess">
                            <div class="account_body_img">
                                <img src="/assets/imgs/socialmedia.png">
                            </div>
                            <span>社媒平台</span>
                        </div>
                        <!-- <div class="account_body_top_name" @click="waynextStep(5)" v-if="userMeal && userMeal[10].lower[49] && userMeal[10].lower[49].value != 3">
                            <div class="account_body_img">
                                <img src="/assets/imgs/video2b_logo.png">
                            </div>
                        -->
                        <div class="account_body_top_name fish_account_body_top_name" :class="{'fish_account_body_top_name--loading':fishSiteListLoading,'fish_account_body_top_name--disabled':fishSiteListLoading||(!fishSiteList&&!fishSiteList.length)}" @click="waynextStep(4)" v-if="liFisherActive">
                            <el-icon name="loading" />
                            <div class="account_body_img">
                                <img src="/assets/imgs/littlefisherman.png">
                            </div>
                            <span>小渔夫</span>
                        </div>
                    </div>
                  <div style="max-height: 350px;overflow: auto;margin-top:40px;">
                    <div class="share_account_body_content" style="margin-top:0">
                        <div class="content_title">默认视频链接地址：<span v-if="surl">（无字幕）</span></div>
                        <div class="content_url" v-text="wurl"></div>
                        <button type="button" v-show="contentClone" class="content_clone" @click="cloneUrl(wurl)">复制</button>
                    </div>
                    <div class="share_account_body_content" v-if="surl">
                        <div class="content_title">有字幕视频链接地址：</div>
                        <div class="content_url" v-text="surl"></div>
                        <button type="button" v-show="contentClone" class="content_clone" @click="cloneUrl(surl)">复制</button>
                    </div>
                    <div class="share_account_body_content" v-for="item in multilingualVideoList">
                      <div class="content_title">{{ item.name }}视频链接地址：</div>
                      <div class="content_url" v-text="item.url"></div>
                      <button type="button" v-show="contentClone" class="content_clone" @click="cloneUrl(item.url)">复制</button>
                    </div>
                  </div>
                </div>
              <div v-show="!firstStep && optionType === 33">
                <choose-language
                  :tts-list="new_video_tts_interface"
                  :current-id.sync="share_video_tts_id"
                  :video-list="multilingualVideoList"
                  :params="params"
                ></choose-language>
              </div>

                <div v-show="!firstStep && optionType==5">
                    <div class="share_video2b_title">请选择Video2B分类:</div>
                    <el-input
                        size="samll"
                        placeholder="可输入关键词搜索分类"
                        suffix-icon="el-icon-search"
                        v-model="video2bKeyword"
                        @change="getVideo2bSiteLists('search')"
                    >
                    </el-input>
                    <div class="share_video2b_option">
                        <div class="left">
                            <div :class="['video2b_name', video2bActive == index ? 'active' : '']" v-for="(site, index) in video2bSiteList" :key="site.id" @click.stop="showVideo2bChild(index)" v-text="site.name"></div>
                        </div>
                        <div class="right">
                            <span :class="['video2b_child', v2bActive.id == child.id ? 'active': '']" v-for="child in video2bSiteChild" :key="child.id" v-text="child.name" @click="v2bActive = child"></span>
                        </div>
                    </div>
                </div>
                <div v-show="!firstStep && optionType==4">
                    <el-radio-group v-model="fish_video" size="small" class="lifisher-share-type">
                        <el-radio-button label="list">到小渔夫页面</el-radio-button>
                        <el-radio-button label="lib">到小渔夫素材库</el-radio-button>
                    </el-radio-group>
                    <div style="margin-bottom:20px" v-if="share_video_tts_types.length">
                        <div class="share_fish_detail_title">多语种视频分享:</div>
                        <el-radio-group v-model="shareTtsType">
                            <template v-for="ttsType in share_video_tts_types">
                                <el-tooltip
                                :content="ttsError ? '字幕生成失败，请重新生成' : '字幕生成中，请稍后再进行分享'"
                                v-if="ttsType.label!==1"
                                :disabled="ttsReady>=ttsType.compare"
                                :key='ttsType.label'
                                >
                                    <el-radio :label="ttsType.label" :disabled="ttsReady<ttsType.compare">{{ttsType.text}}</el-radio>
                                </el-tooltip>
                            </template>
                        </el-radio-group>
                    </div>
                    <div class="share_fish_detail_title">{{fish_video==='lib'?'分享到小渔夫以下素材库：':'分享到小渔夫以下页面：'}}</div>
                    <div class="share_fish_video_option" v-show="fishSiteList.length>0 && (fish_video =='list' || !origin)">
                        <el-checkbox v-model="liFisherAllChecked" :indeterminate="liFisherIndeterminate">选择全部</el-checkbox>
                        <el-checkbox-group class="fish_list_group" v-model="checkFishSiteList" v-show="optionType==4">
                            <el-checkbox v-for="(item,index) in fishSiteList" :key="index" :label="item.id" style="width:calc(50% - 30px);display: inline-flex;align-items: center;height: 32px;}">
                                <span v-text="item.domain"></span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                    <website-tree v-if="fishSiteList.length>0 && origin" v-show="fish_video =='lib'" :website-list="fishSiteList2" @selectedDataChange="selectedDataChange"></website-tree>
                </div>
                <div v-show="!firstStep && optionType==3">
                    <div class="share_cms_detail_title">分享到全网通以下页面：</div>
                    <!-- 非PPT转换视频source!=3 或者 非一键搬家视频官网产品(source!=7 || sharedialog_video_type!=7) 时显示-->
                    <div class="share_cms_detail_option" v-show="type!=3 && isShow_cms_option" v-if="source!=3 && (source!=7 || sharedialog_video_type!=7)">
                        <el-checkbox v-model="cms">
                        </el-checkbox>
                        <span class="share_top_option_label" @click.stop="cmsChangeHandler">产品详情页</span>

                        <el-tooltip class="item" effect="light" content="将分享至对应的商品详情页，但若为单个视频编辑生成的视频则无对应的商品详情"  placement="right">
                            <span class="iconfont icon-warning" style="color:#e6a23c"  v-show="showWarning"></span>
                        </el-tooltip>
                    </div>
                    <div class="share_cms_video_option" v-show="siteList.length>0">
                        <el-checkbox v-model="cms_video" @change="shareCmsVideoChange"></el-checkbox>
                        <span class="share_top_option_label">Video页面</span>
                        <el-checkbox-group v-model="checkSiteList" v-show="optionType==3" @change="cmsVideoChange">
                            <el-checkbox v-for="(item,index) in siteList" :key="index" :label="item.site_id">
                                <span v-text="item.url"></span>
                            </el-checkbox>
                        </el-checkbox-group>
                    </div>
                </div>
                <div v-show="!firstStep && optionType==2">
                    <el-tabs class="share_website_tab" v-model="activeWebsiteIndexTab" @tab-click="handleSelectWebsiteTab"  :class="{'ishare_material_page_open_dialog' : ishare_material == 'material'}">
                        <el-tab-pane label="到视频官网页面" name="websitePageTab">
                            <div class="share_tts_type_box" v-if="share_video_tts_types.length">
                                <div style="padding-bottom: 10px">多语种视频分享:</div>
                                <el-radio-group v-model="shareTtsType">
                                    <el-tooltip
                                    :content="ttsError ? '字幕生成失败，请重新生成' : '字幕生成中，请稍后再进行分享'"
                                    v-for="ttsType in share_video_tts_types" :disabled="ttsReady>=ttsType.compare"
                                    :key="ttsType.label"
                                    >
                                        <el-radio :label="ttsType.label" :disabled="ttsReady<ttsType.compare">{{ttsType.text}}</el-radio>
                                    </el-tooltip>
                                </el-radio-group>
                            </div>
                            <div class="share_website_option" v-show="hasWebsite">
                                <div style="padding-left: 10px">分享到栏目/分类:</div>
                                <div class="website_nav_tree">
                                    <el-tree
                                        v-show="website_list.length!=0"
                                        ref="WebSiteTree"
                                        show-checkbox
                                        highlight-current
                                        :check-strictly="true"
                                        :props="defaultProps"
                                        lazy
                                        node-key="id"
                                        :load="loadWebsite"
                                        @check="checkGroupNode">
                                    </el-tree>
                                    <div class="loading" v-show='website_loading&&website_list.length==0' style="margin:10px 0 10px 30px;">
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                        <span></span>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                        <!-- 素材这个页面的分享按钮打开弹窗时，不显示分享到视频官网资源库这个tab，因为素材库视频没有封面图 -->
                        <el-tab-pane label="到视频官网资源库" name="websiteResourceLibraryTab" v-if="ishare_material != 'material'">
                            <div class="share_tts_type_box" v-if="share_video_tts_types.length">
                                <div style="padding-bottom: 10px">多语种视频分享:</div>
                                <el-radio-group v-model="shareTtsType">
                                    <el-radio :label="ttsType.label" v-for="ttsType in share_video_tts_types" :key="ttsType.label">{{ttsType.text}}</el-radio>
                                </el-radio-group>
                            </div>
                            <div style="padding-left: 10px">分享到资源库:</div>
                            <div class="share_website_option share_website_resource_library_option" v-show="isActiveWebsiteResourceLibrary" :class="{'active' : website_resource_library==true}">
                                <el-checkbox v-model="website_resource_library"></el-checkbox>
                                <span class="share_top_option_label" @click.stop="websiteResourceLibraryChangeHandler">AI视频文件夹</span>
                            </div>
                            <div class="share_top_option_tips tips">备注：仅将视频文件及封面分享到视频官网资源库里的AI视频文件夹</div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <div v-show="!firstStep && optionType==1">
                    <div v-if="new_video_tts_interface.length" class="share-lang-list"
                    >
                        <div class="share-lang-list__label">选择要分享的字幕语种：</div>
                        <el-checkbox-group
                            class="share-lang-list__list"
                            size="small"
                            v-model="share_video_tts_id"
                            ref="radioGroup"
                            @change='chooseNewShareVideoTTsFun'
                        >
                            <div
                                v-for="item in new_video_tts_interface"
                                :key="item.id"
                                :class="[share_video_tts_id.indexOf(item.id)>-1?'share-lang-list__item chooseCheckItem':'share-lang-list__item']"
                                >
                                    <!-- <el-checkbox-button
                                        :label="item.id"
                                        :disabled = "share_video_tts_id_language.indexOf(item.id)==-1"
                                    > -->
                                    <el-checkbox-button
                                        :label="item.id"
                                    >
                                        <img :src="item.icon" />
                                        <span>{{item.languageName}}</span>
                                    </el-checkbox-button>
                            </div>
                            <el-button type="text" size="small" class="share-lang-list__btn" @click="toggleLanguageCollapse"
                                v-show="languageCollapsible&&has_new_video_tts" :icon="languageCollapsed?'el-icon-arrow-down':'el-icon-arrow-up'">{{languageCollapsed?'展开':'收起'}}
                            </el-button>
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click"
                                popper-class='popover_new_share_video_tts'
                            >
                                <div v-loading='new_share_video_tts_Loading'>
                                    <template v-for="(item,index) in newnewVideoTTs">
                                        <div class='language_popover_box' :key='index'>
                                            <h4>{{item.languageName}}</h4>
                                            <el-select
                                            v-model="item.ids"
                                            multiple
                                            size='small'
                                            class='accountOptions'
                                            @change="languagePopoverClick(item)"
                                            placeholder="请选择"
                                            >
                                                <el-option
                                                    v-for="itemcm in item.allOauth"
                                                    :key="Number(itemcm.id)"
                                                    :label="itemcm.display_name"
                                                    :value="Number(itemcm.id)"
                                                >
                                                <div style='padding:0 8px;display:flex;align-items: center;justify-content:space-between;'>
                                                    <span>{{ itemcm.display_name }}</span>
                                                    <span><img :src='itemcm.mediaIcon' width="22" height="22" style='height:22px;width:22px;vertical-align: middle;'/></span>
                                                </div>
                                                </el-option>
                                            </el-select>
                                        </div>
                                    </template>
                                </div>
                                <!-- <el-button slot="reference" class="share-lang-list__btn yuzhong" v-show='has_new_video_tts'>语种分配设置</el-button> -->
                            </el-popover>
                        </el-checkbox-group>
                    </div>
                    <div class="share_platform_option" @click='clickBody'>
                        <div class="share_top_option_label title_box" v-show="!hasNoAccount">
                            <div>
                                <span style="margin-right: 10px">分享到以下社媒平台</span>
                                <el-checkbox label="全选" :indeterminate="isMediaIndeterminate" v-model="isCheckedAllMedia" @change="changeCheckedAllMedia"></el-checkbox>
                            </div>
                            <div class="share_time_type_box">
                                <el-popover
                                    v-if="origin !== 'moveHouse'"
                                    placement="top"
                                    width="430"
                                    trigger="hover">
                                    <p>智能推荐规则->通过社媒数据分析，系统推荐各平台分享时间。</p>
                                    <i style="color: #409eff" slot="reference" class="el-icon-question"></i>
                                </el-popover>
                                <span>
                                    分享时间：
                                    <el-select style="margin-right:10px;width: 105px" size="mini" v-model="shareTimeType" placeholder="请选择">
                                        <el-option v-if="origin !== 'moveHouse'" label="智能推荐" value="3" ></el-option>
                                        <el-option label="立即分享" value="1"></el-option>
                                        <el-option label="定时分享" value="2"></el-option>
                                    </el-select>
                                </span>
                                <span v-show="new_video_tts_interface.length>1 && optionType==1">
                                    语种间隔：
                                    <el-select style="width: 76px" size="mini" v-model="sharingInterval" placeholder="请选择">
                                        <el-option label="不限" value="0"></el-option>
                                        <el-option label="10分钟" value="10"></el-option>
                                        <el-option label="30分钟" value="30"></el-option>
                                        <el-option label="1小时" value="60"></el-option>
                                    </el-select>
                                </span>
                                <el-select style="width: 220px" size="mini" v-show="shareTimeType == 2" v-model="timeZone" placeholder="请选择时区">
                                    <el-option
                                        v-for="item in timeZoneList"
                                        :label="item.name"
                                        :value="item.id"
                                        :key='item.id'
                                        >
                                    </el-option>
                                </el-select>
                                <el-date-picker
                                    style="width: 175px"
                                    size="mini"
                                    v-show="shareTimeType == 2"
                                    v-model="shareTime"
                                    type="datetime"
                                    placeholder="选择日期时间"
                                    format="yyyy-MM-dd HH:mm"
                                    value-format="yyyy-MM-dd HH:mm">
                                </el-date-picker>
                            </div>
                        </div>
                        <el-tooltip class="item" effect="light" content="暂无绑定的社媒账号" placement="right" style="display:none;">
                            <span class="iconfont icon-warning" style="color:#e6a23c" v-show="hasNoAccount"></span>
                        </el-tooltip>
                        <div class="share_platform_options_container" @click='clickBody'>
                            <div class="release_account_options_box" v-show="!hasNoAccount" >
                                <div class="release_options_tabs">
                                    <template v-for="(release,index) in accounts">
                                        <div class="release_tab" v-if="!release.disabled &&(release.account.length>0||release.jujiao_account.length>0)"
                                            :class="current_release_index===index?'active_release':''" :key="release.id"
                                            :style="{'background-color':current_release_index===index?'rgba(0, 126, 255,.2)':'#ffffff'}"
                                        >
                                            <el-checkbox v-model="release.isChecked" @change="releaseHanlder($event,index)" :disabled="release.disabled"></el-checkbox>
                                            <div class="release_item_label"
                                                @click="activeHandler(release, index)">
                                                <span
                                                  class="release_icon"
                                                  :style="{
                                                  backgroundImage: 'url('+release.icon+')',
                                                  backgroundSize: release.media == 3 ? '29px 20px' : '20px 20px'
                                                }"
                                                >
                                                </span>
                                                <span style="font-weight: bold;" v-text="release.name"></span>
                                                <div class="item" v-if="release.name=='YouTube'">
                                                    分享到Youtube平台前必须创建Youtube频道 ，<el-link type="primary" href="https://www.youtube.com/verify_phone_number" target="_blank">手机验证</el-link>
                                                    通过后才可自定义缩略图，60秒内9:16视频将自动发布至 <el-link type="primary" href="https://support.google.com/youtube/answer/10059070?hl=zh-Hans" target="_blank">YouTube Shorts</el-link>
                                                </div>
                                                <div class="item" v-else>{{release.ruleText}}</div>
                                            </div>
                                        </div>
                                    </template>
                                </div>
                                <div class="account_options" v-if="current_release_index>=0">
                                    <div class="share_time_box" v-if="shareTimeList" v-show="shareTimeType == 3">
                                        <span v-text="accounts[current_release_index].name + '推荐分享时间：'"></span>
                                        <el-select size="mini" v-model="shareTimeList[accounts[current_release_index].media].time_zone_id" placeholder="请选择时区">
                                            <el-option
                                                v-for="item in timeZoneList"
                                                :label="item.name"
                                                :value="item.id"
                                                :key='item.id'
                                                >
                                            </el-option>
                                        </el-select>
                                        <el-date-picker
                                            size="mini"
                                            v-model="shareTimeList[accounts[current_release_index].media].time"
                                            type="datetime"
                                            placeholder="选择日期时间"
                                            format="yyyy-MM-dd HH:mm"
                                            value-format="yyyy-MM-dd HH:mm">
                                        </el-date-picker>
                                    </div>
                                    <!-- 官方社媒账号 -->
                                    <div class="official_account_box" v-show="accounts[current_release_index].jujiao_account.length>0" v-loading="video2bSiteListLoading">
                                        <div class="official_account_wrap" v-for="(media,indx) in accounts" :key="indx" v-show="indx==current_release_index">
                                            <el-checkbox v-model="media.jujiao_isChecked" @change="jujiaoChange"></el-checkbox>
                                            <span @click.stop="showJujiao" class="jujiao_labe" :class="media.jujiao_isChecked?'jujiao_checked':''">
                                                聚焦官方账号
                                                <span class="jujiao_drow_icon" :class="{jujiao_up_icon:media.jujiao_isShow}"></span>
                                            </span>
                                            <ul class="official_account_list" v-show="media.jujiao_isShow">
                                                <li class="official_account_item">
                                                    <el-radio-group v-model="media.industry_id" @change="radioChange">
                                                        <el-radio-button :label="official.industry_id"
                                                            v-for="(official,idx) in media.jujiao_account"
                                                            :key="idx">
                                                            <span v-text="official.industry_name"></span>
                                                        </el-radio-button>
                                                    </el-radio-group>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                    <div class="account_options_item" v-for="(account,i) in account_list"
                                        :key="account.id">
                                        <el-checkbox v-model="account.isChecked" :disabled="account.status!=1||account.disabled||account_disabled(account.id)"
                                            @change="accountHandler($event,i)">
                                            <span v-text="get_account_name(account)" class="account_name"></span>
                                            <span
                                                :style="{'color':account.status==2?'#ff9900':
                                                account.status==3?'#f00':'#9d9d9d'}"
                                                class="account_status" v-text="account_status_label(account.status,account.id)"></span>
                                        </el-checkbox>
                                    </div>
                                </div>
                            </div>
                            <no-data-box :is_no_data="hasNoAccount" :data_text="share_dialog_datatext" alink="./help?tab=2&menu_id=38&submenu_id=39"></no-data-box>
                        </div>
                    </div>
                </div>
            </div>
            <div class="share_tdk_body" v-if="isTDKstep">
                <div v-show="!previewVisible&&!advancedSwitch">
                    <el-form class="share_video_tdk_form" :model="tdk" v-for="(tdk,j) in tdkList" :key="j" v-show="j==tdkIndex">
                        <el-form-item
                            prop="title"
                            class="share_video_tdk_item"
                            :show-message="!tdk?.title?.length"
                            :rules="[
                                { required: true, message: '标题不能为空', trigger: 'blur' },
                                { max: tdkTitleRule.maxLength, message: '标题长度需小于'+tdkTitleRule.maxLength, trigger: ['blur', 'change'] },
                            ]"
                        >
                          <div style="position: absolute;top: -30px;height: 20px;">
                            <el-popover
                                placement="right"
                                width="400"
                                trigger="click"
                                popper-class='popover_new_share_video_tts'
                                @show='showChangeLanguage'
                                :popper-options="{ boundariesElement: 'body', gpuAcceleration: false }"
                            >
                              <div v-loading='showChangeLanguageLoading'>
                                <div class='changeLanguageCountry'>
                                  <el-radio-group
                                      v-model="languageTransLates"
                                      size="small"
                                      class="share-lang-list-language"
                                      @input='clickChangeLanguage'
                                  >
                                    <template v-for="item in newnewVideoTTs">
                                      <div
                                          :key="item.id"
                                          class="share-lang-list__item"
                                      >
                                        <el-radio-button :label="item.languageName" :disabled="item.language=='en-gb'||item.languageName=='默认视频'"></el-radio-button>
                                      </div>
                                    </template>
                                  </el-radio-group>
                                </div>
                                <template v-for="(item,index) in newTdk">
                                  <div v-if='item.name==languageTransLates' class='changeLanguageBox' :key="index">
                                    <div class='changeLanguageTitle'>标题</div>
                                    <div class='changeLanguageContent'>
                                      <el-input placeholder="请输入" v-model="item.title">
                                      </el-input>
                                    </div>
                                    <div class='social_box_view'>
                                      <social-media slot="suffix" type="title" :accounts="accounts" :count="item.title.length" />
                                    </div>
                                    <div class='changeLanguageTitle'>关键词</div>
                                    <div class='changeLanguageContent'>
                                      <el-input type="textarea" placeholder="请输入"
                                                v-model="item.keywords"
                                                :autosize="{minRows:3,maxRows:6}"
                                                class="keyword_textarea">
                                      </el-input>
                                    </div>
                                    <div class='social_box_view'>
                                      <social-media v-if="optionType == 1" type="keywords" :accounts="accounts" :count="keywordsLength(item?.keywords)"/>
                                    </div>
                                    <div class='changeLanguageTitle'>描述</div>
                                    <div class='changeLanguageContent'>
                                      <el-input
                                          type="textarea"
                                          placeholder="请输入"
                                          v-model="item.desc"
                                          class="keyword_textarea desc_textarea">
                                      </el-input>
                                    </div>
                                    <div class='social_box_view'>
                                      <social-media v-if="optionType == 1" type="description" :accounts="accounts" :count="item.desc.length"/>
                                    </div>
                                  </div>
                                </template>
                              </div>
                              <el-button slot="reference" class='changeLanguage' type="text" v-if="has_new_video_tts">修改小语种</el-button>
                            </el-popover>

                          </div>
                            <div class="share_video_tdk_label">
                                <p>标题/Title<span class="share_video_tdk_tips" v-text="tdkTitleRule.tip"></span></p>
                                <chat-button
                                  ref="chatBtnTitle"
                                  :type="'title'"
                                  :keywords="tdk.title"
                                  :accounts="accounts"
                                  :chatBtnStatus="chatBtnStatus"
                                  @insert="(val) =>{tdk.title = val}"
                                  @visibleChange="titleChatGPTVisibleChange"
                              ></chat-button>
                            </div>


                          <div class="share_video_input" style="position:relative" v-if="optionType != 1">
                                <seo-match-box :is-first="tdk.first" :keyword="tdk.title" @change-handler="videoTitleChange" @keyword-handler="keywordHandler"></seo-match-box>
                            </div>
                            <div class="share_video_input" v-else>
                                <el-input placeholder="请输入" v-model="tdk.title">
                                </el-input>
                                <div class='social_box_view'>
                                    <social-media slot="suffix" type="title" :accounts="accounts" :count="tdk?.title?.length" />
                                    <social-media-popover slot="suffix" type="title" :accounts="accounts" :count="tdk?.title?.length" />
                                </div>
                            </div>
                        </el-form-item>
                        <el-form-item
                            prop="keywords"
                            class="share_video_tdk_item"
                            :show-message="false"
                            :rules="[
                                { max: tdkKeywordRule.maxLength, message: '关键词长度需小于'+tdkKeywordRule.maxLength, trigger: ['blur', 'change'] },
                            ]"
                        >
                            <div class="share_video_tdk_label" @click='clickBody'>
                                <p>关键词/Keyword<span class="share_video_tdk_tips" v-text="tdkKeywordRule.tip"></span></p>
                              <p>
                                <span v-if="tdkKeywordRule.maxLength" class="share_video_tdk_tips" v-text="keywordsLength(tdk.keywords) + '/' + tdkKeywordRule.maxLength"></span>
                              <chat-button
                                  :type="'keyword'"
                                  :accounts="accounts"
                                  :keywords="tdk.title"
                                  :chatBtnStatus="chatBtnStatus"
                                  @insert="(val) =>{tdk.keywords = val}"
                                  @visibleChange="keywordsChatGPTVisibleChange"
                            ></chat-button>
                              </p>
                            </div>
                            <div class="share_video_input" @click='clickBody'>
                                <el-input type="textarea" placeholder="请输入" v-model="tdk.keywords" :autosize="{minRows:3,maxRows:6}" class="keyword_textarea"></el-input>
                            </div>
                            <div class='social_box_view' @click='clickBody'>
                                <social-media v-if="optionType == 1" type="keywords" :accounts="accounts" :count="keywordsLength(tdk?.keywords)"/>
                                <social-media-popover v-if="optionType == 1" type="keywords" :accounts="accounts" :count="keywordsLength(tdk?.keywords)"/>
                            </div>

                        </el-form-item>
                        <el-form-item
                            prop="desc"
                            class="share_video_tdk_item"
                            :show-message="false"
                            :rules="[
                                { max: tdkDesRule.maxLength, message: '描述长度需小于'+tdkDesRule.maxLength, trigger: ['blur', 'change'] },
                            ]"
                        >
                            <div class="share_video_tdk_label" @click='clickBody'>
                                <p>描述/Description<span class="share_video_tdk_tips" v-text="tdkDesRule.tip"></span></p>
                          <chat-button
                              :type="'desc'"
                              :accounts="accounts"
                              :keywords="tdk.title"
                              @insert="(val) =>{tdk.desc = val}"
                              :chatBtnStatus="chatBtnStatus"
                              @visibleChange="descChatGPTVisibleChange"
                              ></chat-button>
                            </div>

                          <div class="share_video_input" @click='clickBody'>
                                <el-input type="textarea" placeholder="请输入" v-model="tdk.desc" class="keyword_textarea desc_textarea"></el-input>
                            </div>
                            <div class='social_box_view' @click='clickBody'>
                                <social-media v-if="optionType == 1" type="description" :accounts="accounts" :count="tdk.desc?.length||0"/>
                                <social-media-popover v-if="optionType == 1" type="description" :accounts="accounts" :count="tdk.desc?.length||0"/>
                            </div>
                        </el-form-item>
                    </el-form>
                </div>
                <div v-show="advancedSwitch">
                    <new-tdk :tdk='tdkList' :accounts="accounts" @setAccountData='setTdkDataList'></new-tdk>
                </div>
                <div class="share_video_hot_topic" v-if="optionType == 1" v-show="!previewVisible"  @click='clickBody'>
                    <el-popover
                        placement="bottom"
                        width="400"
                        trigger="hover"
                        :disabled='validationList.invalid.length==0'
                        v-if="!advancedSwitch&&validationList.invalid.length!=0"
                    >
                        <div class="tdk_box_tips">打开高级模式可进行优化</div>
                        <div class="tak_poppver_box" v-for="(item,index) in validationList.invalid" :key="index">
                            <div class="tdk_poppver_Title">
                                <img :src="item.icon" alt="">
                                {{item.name}}
                            </div>
                            <div class="tdk_poppver_proposal">{{item.ruleText}}</div>
                        </div>
                        <div slot="reference" class="tdk_tips">你有 {{validationList.invalid.length}} 条社媒排名优化建议</div>
                    </el-popover>
                    <div v-if="tdkList.length">
                        <p class="hot_topic_title">TDK智能生成</p>
                        <div class="share_video_input" style="position:relative">
                            <seo-match-media :is-first="tdkList[0].first" :platform="optionType" @change-handler="mediaVideoTitleChange" @keyword-handler="mediaKeywordHandler"></seo-match-media>
                        </div>
                    </div>
                    <p class="hot_topic_title">#热门话题</p>
                    <el-input @change="getHotTopic" size="small" placeholder="输入关键词搜索热门话题" v-model="hot_topic_keyword" class="input-with-select">
                        <el-button slot="append" icon="el-icon-search"></el-button>
                    </el-input>
                    <p class="hot_topic_tips">行业热门话题榜<span>（点击使用）</span></p>
                    <div class="hot_topic_list" v-loading="hot_topic_loading" v-if="hotTopicList.length">
                        <div class="hot_topic_items" v-for="(hotItem, hotIndex) in hotTopicList" @click="handelHotTopic(hotItem)" :key="hotIndex">
                            <div class="hot_topic_items_num" :class="'index' + hotIndex" v-text="hotIndex+1"></div>
                            <div v-text="hotItem.title"></div>
                            <img class="hot_icon" v-if="hotItem.hot_value" :src="'/assets/imgs/hot' + hotItem.hot_value + '.png'">
                        </div>
                    </div>
                    <div v-else class="hot_topic_nodata" v-text="'暂无相关的行业热门话题'"></div>
                </div>
                <div class="share_video_hot_topic" v-else-if="optionType == 2" style="padding-right:14px">
                    <p class="hot_topic_title">截取示例 GIF</p>
                    <div class="gif-preview-area" :style="gifUrl?{backgroundImage:'url('+gifUrl+')'}:{}">
                        <el-button class="gif-preview-area__btn" @click="enterVideoCrop">视频截取</el-button>
                        <el-button icon="el-icon-close" type="danger" circle v-show="gifUrl" class="gif-preview-area__remove" @click="removeCroppedGif"></el-button>
                    </div>
                    <p class="gif-preview-desc">使用视频截帧技术生成 GIF 动图需浏览器版本支持</p>
                </div>
                <div v-show="cropperShowing" class="video-cropper" v-loading="cropperLoading">
                    <video v-if="wurl" :src="wurl" class="cropped-video" crossorigin ref="cropVideo" @loadedmetadata="handleMetadataLoaded"
                        @timeupdate="handleCurrent" @play="handlePlay" @pause="handlePause" controls />
                    <div class="video-cropper-container">
                        <div class="video-cropper-container__start">
                            <span class="el-icon-info video-cropper-container__icon"></span>
                            请拖动滑块，整体调整视频截取位置
                        </div>
                        <div class="video-cropper-container__end">
                            {{sharedialog_video_name}}
                            (时长: {{ formatDuration(totalDuration) }})
                        </div>
                        <el-slider
                            class="slide-container__slider"
                            :min="0"
                            :max="totalDuration"
                            :step="0.01"
                            v-model="current"
                            :disabled="playing"
                            :formatTooltip="formatDuration"
                            v-if="false"
                        />
                        <div class="video-cropper-container__body video-cropper-container__item">
                            <div
                                class="track"
                                :class="{ 'track--selected': cropping }"
                                :style="trackStyle"
                                @mousedown="handleMouseDown"
                            >3s</div>
                        </div>
                    </div>
                </div>
                <div class="share-preview-box" v-if="previewVisible">
                    <el-tabs type="border-card" v-model="previewingTab">
                        <el-tab-pane v-for="ac in previewAccounts" :key="ac.media" :name="ac.media">
                            <img :src="ac.icon" slot="label" :alt="ac.name" />
                            <div class='previewBox' v-loading='showChangeLanguageLoading'>
                                    <div class='switchlanguages'>
                                        切换语种
                                        <el-radio-group v-model="languageTransLates" @input='clickChangeLanguage'>
                                            <template v-for="item in newnewVideoTTs">
                                                <div :key="item.id" v-if="item.id!=''" class="switchlanguages_item">
                                                    <el-radio-button
                                                    :label="item.languageName"
                                                    >
                                                    </el-radio-button>
                                                </div>
                                            </template>
                                        </el-radio-group>
                                    </div>
                                <div class='previewBoxVideo'>
                                    <share-preview :media="ac.media" :video="actualPreviewUrl" :tdk="sharePreviewTdk()" />
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <div class="share_account_footer" v-show="!contentClone">
                <el-button class="prev_btn comfirm_btn" size="normal" style="color:#000;opacity:0.65;float:left" @click="prevStep" v-show="!contentClone&&!defaultTdk">上一步</el-button>

                <div v-if="cropperShowing" class="cropper-actions">
                    <p>截取后时长: {{formatDuration(cropPos)}} &ndash; {{formatDuration(cropPos+3)}}</p>
                    <!-- el-button class="cropper-actions__btn" @click="togglePlay">{{playing?'暂停':'播放'}}</el-button -->
                    <el-button class="cropper-actions__btn" type="primary" v-if="cropperShowing" @click="handleVideoCrop" :disabled="!totalDuration" :loading="cropperLoading">确认截取</el-button>
                </div>
                <template v-else>
                  <template v-if="optionType === 33">
                    <el-button
                      class="comfirm_btn"
                      size="normal"
                      style="color:#fff;"
                      :style="{'background':'#409EFF'}"
                      :loading="btnLoading1"
                      @click="confrimHandler"
                    >确定</el-button>
                  </template>
                  <template v-else>
                    <!-- 全网通、视频官网页面、社媒平台,需要经过下一步tdk表单步骤时显示这个点击确认 -->
                    <el-button class="comfirm_btn" size="normal"  style="color:#fff;"  v-show="isTDKstep"
                                :style="{'background':'linear-gradient(180deg,rgba(57,181,74,1) 0%,rgba(52,170,68,1) 98%)'}"
                                :loading="isLoading"
                                @click="confrimHandler">确定</el-button>

                    <!-- 小渔夫代理商、视频官网资源库,不需要经过下一步tdk表单步骤就直接显示这个点击确认 -->
                    <el-button class="comfirm_btn" size="normal"  style="color:#fff;"  v-show="!isTDKstep && (isActiveWebsiteResourceLibrary || optionType==4) && (firstStep || optionType!=1)"
                                :style="{'background':'#409EFF'}"
                                :loading="isLoading"
                                @click="confrimHandler">确定</el-button>

                    <!-- 全网通、视频官网页面(非视频官网资源库)、社媒平台、非小渔夫代理商、非无社媒账号(社媒平台有账号)时,需要经过下一步tdk表单步骤时显示这个点击下一步 -->
                    <el-button class="next_btn comfirm_btn" size="normal" :loading="isLoadingTdk" style="color:#000;opacity:0.65" @click="nextStep" v-show="!isTDKstep && !useWebsiteNext && (hasWebsite || (!isActiveWebsiteResourceLibrary && optionType!=2)) && optionType!=4 && (!hasNoAccount || optionType!=1)">下一步</el-button>
                    <el-button class="next_btn comfirm_btn el-button--primary" size="normal" :disabled="!currentWebsiteUrl" @click="openWebsite" v-if="useWebsiteNext">下一步</el-button>

                    <el-button class="comfirm_btn" size="normal" style="color:#000;opacity:0.65;float:right" @click="closeDialog" v-show="!hasNoAccount">取消</el-button>

                    <!-- 只在社媒这个入口进去无社媒账号数据时才显示去授权 -->
                    <el-button class="comfirm_btn to_authorize_btn" size="normal" style="color:#fff;float:right" type="primary" @click="toAuthorizePage" v-show="hasNoAccount && optionType==1">去授权</el-button>
                    <el-button :disabled="!previewAccounts.length" style="opacity:.65;color:#000" v-show="isTDKstep&&optionType == 1&&!previewVisible" class="next_btn comfirm_btn" @click="showPreview">预览</el-button>
                    <div v-show="showPrivacy" class="privacy-box">
                      <span style="margin-right: 8px;font-size: 14px;">隐私: </span>
                      <el-select
                        v-model="privacyStatus"
                        size="mini"
                        style="width: 115px;"
                      >
                        <el-option
                          v-for="item in privacyOptions"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        ></el-option>
                      </el-select>
                    </div>
                  </template>
                </template>
            </div>
        </div>
        <el-button ref="popo" id="popo-btn" ></el-button>
    </div>
</template>
<script>
import hightTdkOne from './newTdk.vue'
import socialmedia from './socialMedia.js'
import sharePreview from './sharePreview.js'
import socialMediaPopover from './socialMediaPopover.js'
import { shareDialogStore } from './shareDialogStore.js'
import chatButton from './chatGPT/index.vue'
import websiteTree from './websiteTree'
import ChooseLanguage from './ChooseLanguage.vue'
export default {
  components: {
    'social-media-popover': socialMediaPopover,
    'social-media': socialmedia,
    'share-preview': sharePreview,
    'new-tdk': hightTdkOne,
    'chat-button': chatButton,
    'website-tree': websiteTree,
    'choose-language': ChooseLanguage
  },
    props: {
        origin: {
            type: String,
            default: ''
        },
        source: {
            type: Number,
            default: 1
        },
        title: {
            type: String,
            default: ""
        },
        show: {
            type: Boolean,
            default: false
        },
        type: {
            type: Number,
            default: 1   //1 分享 2 批量生成  3 单个视频编辑  4批量分享
        },
        params: {
            type: Array,
            default() {
                return []
            }
        },
        theme: {
            type: Object,
            default() {
                return {}
            }
        },
        wurl: {
            type: String,
            default: ""
        },
        surl: {
            type: String,
            default: "" // 有字幕无翻译时才有
        },
        ishare_material: {
            type: String
        },
        sharedialog_video_id: {
            type: String
        },
        sharedialog_video_name: {
            type: String
        },
        sharedialog_video_type: {
            type: String
        },
        tts: {
            type: Array,
            default: []
        },
        specs: {
            type: Number,
            default: 1   //视频比例 1（16:9）2（1:1）3（9:16）
        },
        timeZoneList: {
            type: Array,
            default() {
                return [];
            }
        },
        defaultTdk: {
            type: Object
        },
        userInfo: {
            type: Object,
            default: null
        },
        legacy: Boolean,
        websiteUrl: String,
        parent: Boolean,
        ttsReady: Number,
        platformList: {
            type: Array
        }
    },
    async mounted() {
        //初始化时获取小渔夫站点
        // if (this.liFisherActive) {
        //     // 小渔夫代理商
        //     this.fishSiteLists();
        // }
    },
    watch: {
        // source: {
        //     immediate: true,
        //     handler(val) {
        //         this.source = val;
        //         // console.log(val)
        //     }
        // },
        show: {//监听弹框打开，初始化数据
            immediate: true,
            handler(val) {
                if (val) {
                  this.getNewShareVideoLanguage()
                    console.log(this.shareType)
                    this.advancedSwitch = false;
                    this.hot_topic_keyword = ''
                    this.get_share_times()
                    this.getHotTopic()
                    this.siteLists();
                    console.log('新0129')
                  console.log(this.tts)
                    if (this.liFisherActive) {
                        // 小渔夫代理商
                        this.fishSiteLists();
                    }
                    this.dialog_title = '视频分享';
                    this.contentClone = true;
                    this.firstStep = true;
                    let arr = store.getters.get_platform_list();
                    // 判断是否有video2b授权账号
                    for (let index = 0; index < arr.length; index++) {
                        if (arr[index].media == 14) {
                            this.hasVideo2bAccount = true;
                            // this.getVideo2bSiteLists();
                        }
                    }
                    let list = account_list_format(this.platformList, store.getters.get_platform_list()) // FIXME: why twice?
                    let official_account_list = store.getters.get_official_account();
                    if (arr.length == 0 && official_account_list.length == 0) {//没有已授权的社媒账号
                        this.hasNoAccount = true;
                    }
                    for (let x = official_account_list.length - 1; x >= 0; x--) {
                        let industry_list = official_account_list[x].industry_list;
                        // console.log(official_account_list[x].last_select_industry_id)
                        for (let z = 0; z < industry_list.length; z++) {
                            industry_list[z].isChecked = false;
                            if (official_account_list[x].last_select_industry_id == industry_list[z].industry_id) {
                                this.$set(industry_list[z], 'isChecked', true);
                            }
                        }
                    }
                    for (let i = list.length - 1; i >= 0; i--) {
                        let platform = list[i];
                        platform.jujiao_isChecked = false;
                        platform.jujiao_isShow = true;
                        platform.industry_id = undefined;
                        platform.jujiao_account = [];
                        // console.log(platform)
                        for (let y = 0; y < official_account_list.length; y++) {
                            if (platform.media == official_account_list[y].media_type) {//同平台下有官方账号
                                platform.jujiao_account = official_account_list[y].industry_list;
                            }
                        }
                        this.current_release_index = undefined
                    }
                    console.log(arr);
                    this.accounts = list; // TODO: add v2b platform
                    this.showShareDialog = true;
                    if (this.defaultTdk) {
                        this.isTDKstep = true;
                        this.firstStep = false;
                        this.contentClone = false;
                        this.optionType = 1;
                        this.dialog_title = '检查分享 TDK';
                        this.tdkList = [
                            Object.assign({}, this.defaultTdk)
                        ];
                        // this.$set(this.tdkList,[],this.defaultTdk);

                    }

                    this.cropPos = 0;

                    this.cropping = false;
                    this.cropperShowing = false;
                    this.cropperLoading = false;
                    this.previewVisible = false;
                } else {
                    this.showShareDialog = false;

                    this.handleMouseUp();
                    this.removeCroppedGif();
                }
            }
        },
        theme: {
            immediate: true,
            handler(val) {
                this.color_scheme = val
            }
        },
        sharedialog_video_id: {
            immediate: true,
            handler(val) {
                // console.log(val);
                this.share_video_id = val
                if (val) {
                    this.getVideo(val)
                }
            }
        },
        sharedialog_video_name: {
            immediate: true,
            handler(val) {
                // console.log(val);
                this.share_video_name = val
            }
        },
        sharedialog_video_type: {
            immediate: true,
            handler(val) {
                // console.log(val);
                this.share_video_type = val
            }
        },
        tts: {
            immediate: true,
            deep: true,
            handler(val) {
                this.share_video_tts_id = [];
                this.share_video_tts = []
                this.share_video_tts_types = []
                this.hasTranslate = ''
                val.forEach(item => {
                    let ttsItem = {}
                    ttsItem.id = item.id ? item.id : ''
                    ttsItem.name = item.language;
                    if (item.language) {
                        this.hasTranslate = 'yes'
                        ttsItem.language = item.name.split('（')[0]
                        ttsItem.icon = item.icon
                    } else if (item.language == '') {
                        this.hasTranslate = 'no'
                        ttsItem.language = '字幕视频'
                        ttsItem.icon = '/assets/imgs/tts_icon.png'
                    } else {
                        ttsItem.language = '默认视频'
                        ttsItem.name = '默认视频'
                        ttsItem.icon = '/assets/imgs/def_video.png'
                        ttsItem.id = 0;
                    }
                    if (item.status == 1) {
                        this.share_video_tts.push(ttsItem)
                    }
                });
                this.ttsError = val.some(item => item.status === -1);
                switch (this.ttsReady) {
                    case 0:
                        this.shareTtsType = 0;
                        break;
                    case 1:
                        this.shareTtsType = 2;
                        break;
                    default:
                        this.shareTtsType = this.hasTranslate === 'yes' ? 1 : 2;
                }

                this.setTtsTypes();
            }
        },
        optionType: {
            handler(val) {
                switch (val) {
                    // 视频官网
                    case 2:
                        this.tdkTitleRule = {
                            tip: "(请输入少于120字符，标题可采用“关键词+视频内容主题+品牌+型号”的方式编写)",
                            maxLength: 120
                        }
                        this.tdkKeywordRule = {
                            tip: "(多个关键词可用英文逗号','隔开，请输入少于350字符)",
                            maxLength: 350
                        }
                        this.tdkDesRule = {
                            tip: "(请输入少于5000字符，描述可以包含视频内容的概述和匹配视频内容的关键词)",
                            maxLength: 5000
                        }
                        break;
                    // 全网通
                    case 3:
                        this.tdkTitleRule = {
                            tip: "(请输入少于250字符，标题可采用“关键词+视频内容主题+品牌+型号”的方式编写)",
                            maxLength: 250
                        }
                        this.tdkKeywordRule = {
                            tip: "(多个关键词可用英文逗号','隔开，请输入少于250字符)",
                            maxLength: 250
                        }
                        this.tdkDesRule = {
                            tip: "(请输入少于750字符，描述可以包含视频内容的概述和匹配视频内容的关键词)",
                            maxLength: 750
                        }
                        break;
                    default:
                        // this.initmediaTdkRule()
                        break;
                }
            }
        },
        cms: {
            handler(val) {
                if (val) {
                    this.checkSiteList = []
                    this.cms_video = false
                }
            }
        },
        cms_video: {
            handler(val) {
                if (val) {
                    this.cms = false
                }
            }
        },
        current(val) {
            if (!this.playing && this.$refs.cropVideo) {
                this.$refs.cropVideo.currentTime = val;
            }
        },
        cropPos(val) {
            if (!this.playing) {
                this.current = val;
            }
        },
        languageCollapsed(val) {
            if (this.$refs.radioGroup) {
                if (val && !this.languageCollapsible) {
                    $(this.$refs.radioGroup.$el).css('height', 44);
                    this.languageCollapsible = true;
                    return;
                }
                $(this.$refs.radioGroup.$el).animate({
                    height: val ? 44 : this.$refs.radioGroup.$el.scrollHeight
                }, 200);
            }
        }
    },
    data() {
        return {
          privacyStatus: 'public',
          privacyOptions: [{ label: '私享', value: 'private' }, { label: '公开', value: 'public' }, { label: '不公开列出', value: 'unlisted' }],
          btnLoading1: false,
          userCounter: JSON.parse(sessionStorage.getItem('userCounter')),
          fishSiteList2:[],
          fishsiteCategory: {},
          titleChatGPTVisible: false,
          keywordsChatGPTVisible: false,
          descChatGPTVisible: false,
            siteList: [],
            fishSiteList: [],
            fishSiteListLoading: false,
            is_hasaccount: true,
            platform: '',//生成/分享 方式
            current_release_index: undefined,//当前激活展开社媒平台
            isLoading: false,
            hasNoAccount: false,
            share_dialog_datatext: {
                txt: "您还没有授权任何社媒平台",
                tips: "",
                btn: "授权前必看"
            },
            accounts: [],
            text: '',
            color_scheme: {
                main_color: '#37474F',//主体色
                primary_color: '#23C9E5',//字体色
                last_color: '#0D6E7B'//控件色
            },
            checkSiteList: [],
            checkFishSiteList: [],
            website_list: [],
            website_loading: false,
            website_nav: undefined,
            hasWebsite: true,//是否显示视频官网页面tab
            activeWebsiteIndexTab: 'websitePageTab',//视频官网tab，默认选中显示视频分享到视频官网页面
            isActiveWebsiteResourceLibrary: false,//是否显示视频官网资源库tab
            cms: false,
            cms_video: false,
            release: false,
            website: false,//是否分享到视频官网页面
            website_resource_library: false,//是否分享到视频官网资源库
            fish: false,
            fish_video: 'list',
            optionType: undefined,
            defaultProps: {
                children: 'children',
                label: 'label'
            },
            isTDKstep: false,//是否
            tdkIndex: 0,//当前编辑的tdk
            tdkList: [],//视频tdk列表
            isLoadingTdk: false,//tdk加载中
            dialog_title: '分享',//弹框标题,
            hot_topic_keyword: '', // 热门话题关键字
            hot_topic_loading: false,
            hotTopicList: [], // 热门话题列表
            showShareDialog: false,
            contentClone: true,
            firstStep: true,
            userOrigin: store.getters.get_user_origin(),//用户来源，5代表小渔夫用户
            share_video_id: '',
            share_video_name: '',
            share_video_type: '',
            share_video_shape: 0,
            share_video_tts: [], // 分享到社媒的语种列表
            share_video_tts_id: [], // 分享到社媒的语种
            share_video_tts_types: [], // 分享到视频通官网的字幕类型列表
            shareTtsType: 0, // 分享到视频通官网的字幕类型
            userMeal: store.getters.get_user_meal(), // 用户套餐
            shareTimeType: '1', // 分享时间类型 1.立刻分享，2.定时分享，3.智能推荐
            timeZone: 1, // 时区值
            shareTime: null, // 分享时间
            tdkTitleRule: {}, // tdk标题规则
            tdkKeywordRule: {}, // tdk关键词规则
            tdkDesRule: {}, // tdk内容规则,
            shareTimeList: null, // 分享建议时间
            video2bSiteListLoading: false, // video2b分类loading
            video2bKeyword: [], // video2b分类关键词
            video2bSiteList: [], // video2b分类
            video2bSiteChild: [], // video2b二级分类
            hasVideo2bAccount: false, // 是否有video2b授权账号
            video2bActive: 0, // video2b选中的一级分类下标
            v2bActive: {}, // video2b选中的二级分类
            isCheckedAllMedia: true, // 是否全选社媒
            isMediaIndeterminate: false, // 是否选中部分社媒
            hasTranslate: '', // 是否使用翻译
            websiteNavigationIds: [],
            websiteShareMsgs: '',
            totalDuration: 0,
            cropPos: 0,
            cropping: false,
            current: 0,
            playing: false,
            cropperShowing: false,
            gifUrl: '',
            cropperLoading: false,
            ttsError: false,
            previewVisible: false,
            previewAccounts: [],
            previewingTab: '',
            languageCollapsible: false,
            languageCollapsed: false,
            new_share_video_tts:[],
            share_video_tts_id_language:[],
            languageTransLates:'',
            newTdkList:[],
            showChangeLanguageLoading:false,
            newTdk:[],
            sharingInterval:30,
            newnewVideoTTs:[],
            new_video_tts_interface:[],
            new_share_video_tts_Loading:false,
            chooseCheckItem:[],
            advancedSwitch:false,
            seniorData:{},
            newWebsiteCheckedKeys:[]
        }
    },
    created() {
        this.websiteNextCount = 0;
        if (!this.userMeal) {
            my_http_ajax(my_video_request_api.user_meal, 'GET', {}, this).then(resp => {
                this.userMeal = resp.data
                store.mutations.set_user_meal(resp.data)
            });
        }
        this.getTimeZone();
        this.getHotTopic();
    },
    methods: {
        selectedDataChange(val) {
            this.fishsiteCategory = val
        },
      titleChatGPTVisibleChange(val) {
        console.log(val)
        this.titleChatGPTVisible = val
      },
      keywordsChatGPTVisibleChange(val) {
        console.log(val)
        this.keywordsChatGPTVisible = val
      },
      descChatGPTVisibleChange(val) {
        console.log(val)
        this.descChatGPTVisible = val
      },
        GetQueryString(name) {
            var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
            var r = window.location.search.substr(1).match(reg);
            if (r != null) return unescape(r[2]); return null;
        },
        clickBody(){
            this.$refs.popo.$el.click();
        },
        async getTimeZone() {
            let res = await my_http_ajax(my_video_request_api.share_time_zone, "GET", {}, this);
            if (res) {
                this.$emit('update:timeZoneList', res.data);
            }
        },
        // 获取热门话题
        async getHotTopic() {
            this.hot_topic_loading = true
            let res = await my_http_ajax(my_video_request_api.hot_topic, "GET", {
                page: 1,
                limit: 10,
                keyword: this.hot_topic_keyword
            }, this);
            if (res) {
                this.hotTopicList = res.data.list
                this.hot_topic_loading = false
            }
        },
        // 热门话题点击追加title
        handelHotTopic(item) {
            let queryList = item.title.split(' ')
            let query = ''
            queryList.forEach(item => {
                query += item
            })
            if (this.tdkList[this.tdkIndex].title.indexOf(query) === -1) {
                this.tdkList[this.tdkIndex].title += ` #${query}`
                this.$forceUpdate()
                this.$nextTick(() => {
                    document.getElementById('seo_match_input').focus()
                })
                my_http_ajax('/api/hot-topic/add-use-count', "POST", {
                    tag_id: item.id,
                    query: item.title
                }, this);
            }
        },
        async getVideo(id) {
            if (this.ishare_material !== "material" && this.origin !== 'moveHouse') {
                let res = await my_http_ajax(my_video_request_api.video_basics, "GET", { id }, this);
                if (res) {
                    this.share_video_shape = res.data.shape
                }
            }
        },
        async siteLists() {
            let siteList = [];
            let self = this;
            console.log(store.getters.get_site_list())
            if (store.getters.get_site_list()) {
                siteList = store.getters.get_site_list();
            } else {
                let res = await my_http_ajax(my_video_request_api.site_list, "POST", {}, self);
                if (res.data.length > 0) {
                    siteList = res.data;
                }
            }
            this.siteList = siteList;
        },
        async fishSiteLists() {
            this.fishSiteListLoading = true;
            let fishSiteList = [];
            let self = this;

            let res = await my_http_ajax(my_video_request_api.fish_site_list, "GET", {}, self);
            this.fishSiteListLoading = false;
            if (res?.data?.length > 0) {
                fishSiteList = res.data;
            }
            this.fishSiteList = fishSiteList;
            const fishSiteList2 = JSON.parse(JSON.stringify(fishSiteList))

            this.fishSiteList2 = fishSiteList2;
        },
        // 获取video2b分类
        async getVideo2bSiteLists(search) {
            if (search != 'search' && this.video2bKeyword) {
                this.video2bKeyword = ''
            }
            this.video2bSiteChild = [];
            this.video2bSiteList = '';
            this.v2bActive = {};
            this.video2bActive = 0;
            this.video2bSiteListLoading = true;
            let res = await my_http_ajax(my_video_request_api.video2b_site_list, "GET", {
                search: this.video2bKeyword
            }, this);
            label: if (res.data.list.length > 0) {
                this.video2bSiteList = res.data.list;
                // if (this.userInfo) {
                //     if (res.data.list.some((item, i) => {
                //         if (this.userInfo.parent_id === item.category_id) {
                //             this.video2bActive = i;
                //             let children = res.data.list[i]._child;
                //             children.some(c => {
                //                 if(c.category_id === this.userInfo.industry_id) {
                //                     this.v2bActive = c;
                //                 }
                //             });
                //             this.video2bSiteChild = children;
                //             return true;
                //         }
                //         return false;
                //     })) {
                //         break label;
                //     }
                // }
                this.video2bSiteChild = res.data.list[0]._child;
                this.v2bActive = this.video2bSiteChild[0] || {};
            }
            this.video2bSiteListLoading = false;
        },
        // 展示Video2b二级分类
        showVideo2bChild(index) {
            this.video2bActive = index;
            this.video2bSiteChild = this.video2bSiteList[index]._child
        },
        mediaVideoTitleChange(item) {

            this.$set(this.tdkList[this.tdkIndex], 'title', item.title)
            this.$set(this.tdkList[this.tdkIndex], 'title_id', item.id)
            if(this.advancedSwitch){
                shareDialogStore.commit('setNewTitleSearch',item.title)
            }
        },
        videoTitleChange(value) {
            this.$set(this.tdkList[this.tdkIndex], 'title', value)
        },
        keywordHandler(value) {
            if (value === undefined) return;
            this.$set(this.tdkList[this.tdkIndex], 'keywords', value)
            let video_name = this.tdkList[this.tdkIndex].title;
            let params = {
                video_name,
                v_id: this.share_video_id
            };
            if (value) {
                params.keywords = value;
            }
            this.getVideoDesc(params)
        },
        async mediaKeywordHandler(data) {
            if (data.item === undefined) return;
            let params = {
                video_name: data.item.title,
                v_id: this.share_video_id
            }
            this.isLoadingTdk = true;
            let res = await my_http_ajax(my_video_request_api.seo_keyword, "GET", {
                title: data.item.title,
                keyword: data.keyword
            }, this)
            if (res && res.data.keyword) {
                this.$set(this.tdkList[this.tdkIndex], 'keywords', res.data.keyword)
                if(this.advancedSwitch){
                    shareDialogStore.commit('setNewKeysSearch',res.data.keyword)
                }
                params.keywords = res.data.keyword
            }
            this.getVideoDesc(params)
        },
        // 获取视频描述desc
        async getVideoDesc(data) {
            let platform // 1社媒平台,2全网通,4视频官网,6小渔夫站点视频列表
            switch (this.optionType) {
                case 1:
                    platform = 1
                    break;
                case 2:
                    platform = 4
                    break;
                case 3:
                    platform = 2
                    break;
                case 4:
                    platform = 6
                    break;
            }
            data.platform = platform
            let res = await my_http_ajax(my_video_request_api.seo_desc, "GET", data, this);
            if (res) {
                if (res.data.desc) {
                    let desc = res.data.desc.replace(/<br>/g, '\n');
                    this.$set(this.tdkList[this.tdkIndex], 'desc', desc)
                    if(this.advancedSwitch){
                        shareDialogStore.commit('setNewDescSearch',desc)
                    }
                }
            }
            this.isLoadingTdk = false
        },
        showJujiao() {
            let bol = !this.accounts[this.current_release_index].jujiao_isShow
            this.$set(this.accounts[this.current_release_index], 'jujiao_isShow', bol)
        },
        radioChange(e) {
            console.log({ e }, this.accounts[this.current_release_index].industry_id);
            this.$set(this.accounts[this.current_release_index], 'jujiao_isChecked', true)
            this.$set(this.accounts[this.current_release_index], 'isChecked', true)
            this.release = true;
        },
        jujiaoChange(e) {
            // console.log({e});
            let index = this.current_release_index;
            if (e) {//选中聚焦官网
                this.$set(this.accounts[index], 'jujiao_isShow', true)
                this.$set(this.accounts[index], 'isChecked', true)
                this.release = true;
                let jujiao_accounts = this.accounts[index].jujiao_account;
                let hasChecked = this.check_arr_hasChecked(jujiao_accounts);
                if (!hasChecked && jujiao_accounts.length > 0) {
                    this.$set(this.accounts[index], 'industry_id', this.accounts[index].jujiao_account[0].industry_id)
                }
            } else {
                this.accounts[index].jujiao_account.forEach((account, i) => {
                    this.$set(this.accounts[index], 'industry_id', undefined)
                })
                // 判断是否用户账号无选中
                if (!this.check_arr_hasChecked(this.accounts[index].account)) {
                    this.$set(this.accounts[index], 'isChecked', false)
                }
                if (!this.check_arr_hasChecked(this.accounts)) {
                    this.release = false;
                }
            }
        },
        // 遍历数组中的对象是否有选中
        check_arr_hasChecked(arr) {
            let hasChecked = false;
            arr.forEach((item) => {
                hasChecked = hasChecked || item.isChecked
            })
            return hasChecked;
        },
        // 素材分享获取tdk
        getmaterialTDK(id) {
            let self = this;
            this.isLoadingTdk = true;
            this.dialog_title = '检查分享TDK';
            var token = get_cookie_token();
            self.isTDKstep = true;
            console.log('getmaterialTDK', my_video_request_api.material_share_tdk);
           console.log('$',$)
           console.log('$', $.ajax)
            $.ajax({
                url: my_video_request_api.material_share_tdk,
                async: true,
                type: 'POST',
                data: { material_id: id },
                dataType: 'json',
                headers: {
                    'Authorization': token
                },
                success: function (res) {
                    self.isLoadingTdk = false;
                    if (res.status == 1) {
                        // 有分享记录
                        let data = res.data;
                        self.tdkList = [];
                        data.first = true;
                        data.title = data.content;
                        data.id = id;
                        data.classify = 2;
                        if(!data.title) {
                            data.title = ''
                        }
                        if(!data.desc) {
                            data.desc = ''
                        }
                        if(!data.keywords) {
                            data.keywords = ''
                        }
                        self.tdkList.push(data);
                        console.log('tdkList',self.tdkList);
                    } else {
                        // 无分享记录时
                        self.tdkList = [];
                        self.tdkList.push({ 'id': id, 'first': true, 'desc': "", 'keywords': "", 'title': "", 'classify': 2 })
                        // console.log(self.tdkList)
                    }
                }
            })
        },
        /* 获取视频tdk */
        async getVideoTDK(id) {
            let self = this;
            let params = {
                id
            }
            let navigation_id
            if (this.website) {
                let arr = this.$refs.WebSiteTree.getCheckedKeys()
                navigation_id = arr[arr.length - 1]
            }
            this.isLoadingTdk = true;
            this.dialog_title = '检查分享TDK';
            if (navigation_id) {
                params.navigation_id = navigation_id
            }
            this.isTDKstep = true;
            let res = await my_http_ajax(my_video_request_api.video_tdk, "GET", params, this);
            this.isLoadingTdk = false;
            if (res) {
                my_self_logs('获取视频tdk', res)
                res.data.forEach((item, idx) => {
                    if (item.desc) {
                        res.data[idx].desc = item.desc.replace(/<br>/g, '\n')
                    }
                    if (item.title) {
                        res.data[idx].first = true;
                    }
                    // 去除热点词
                    let textList = item.title.split(' ')
                    let text = []
                    textList.forEach((textItem) => {
                        if (textItem.charAt(0) != '#') {
                            text.push(textItem)
                        }
                    })
                    item.title = text.join(' ')
                })
                let data = res.data;
                this.tdkList = data;
                this.newTdkList = Object.assign({},data[0])
                this.changeLanguageData();
            }
        },
        /* 获取视频tdk */
        async getMoveHouseVideoTDK(id) {
            let self = this;
            let params = {
                id
            }
            let navigation_id
            if (this.website) {
                let arr = this.$refs.WebSiteTree.getCheckedKeys()
                navigation_id = arr[arr.length - 1]
            }
            this.isLoadingTdk = true;
            this.dialog_title = '检查分享TDK';
            if (navigation_id) {
                params.navigation_id = navigation_id
            }
            this.isTDKstep = true;
            let res = await my_http_ajax(my_video_request_api.reptile_video_product_detail, "get", params, this);
            this.isLoadingTdk = false;
            if (res) {
                my_self_logs('获取视频tdk', res)
                var newArray = [res.data];
                console.log(res.data,newArray,'~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
                newArray.forEach((item, idx) => {
                    if (item.description) {
                        newArray[idx].description = item.description.replace(/<br>/g, '\n')
                        newArray[idx].desc = item.description
                    }
                    if (item.title) {
                        newArray[idx].first = true;
                    }
                    // 去除热点词
                    let textList = item.title.split(' ')
                    let text = []
                    textList.forEach((textItem) => {
                        if (textItem.charAt(0) != '#') {
                            text.push(textItem)
                        }
                    })
                    item.title = text.join(' ')
                })
                let data = newArray;
                console.log(newArray)
                this.tdkList = data;
                console.log(this.tdkList,'~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~')
            }
        },
        sharePreviewTdk(){
            var item = this.newTdk.filter(a=>{
                return a.name==this.languageTransLates;
            })
            if(item.length>0){
                return item[0];
            }else{
                return this.tdkList[0]
            }
        },
        checkIdentical(){
            var _t = this;
            //判断内容是否改变，改变了返回false，重新赋值
            if(_t.tdkList.some(a=>{
                console.log(a)
                if(a.title==_t.newTdkList.title
                    &&
                    a.keywords==_t.newTdkList.keywords
                    &&
                    a.desc==_t.newTdkList.desc
                  ){
                    return true;
                }
                _t.newTdkList = Object.assign({},_t.tdkList[0]);
                _t.newTdk.forEach(i=>{
                    i.title =  _t.newTdkList.title;
                    i.keywords==_t.newTdkList.keywords;
                    i.desc==_t.newTdkList.desc;
                })
                return false;
            })){
                // 内容没改变判断是否已经翻译,已经翻译返回false
                var check = _t.newTdk.some(a=>{
                    if(a.name==_t.languageTransLates){
                        console.log(a.language,_t.languageTransLates)
                        console.log(a.title,_t.newTdkList.title)
                        if(a.title==_t.newTdkList.title&&a.keywords==_t.newTdkList.keywords&&a.desc==_t.newTdkList.desc){
                            return true;
                        }
                        return false;
                    }
                })
                return check;
            }else{
                // 因为改变了，所以重新请求
                return true;
            }
        },
        getAccountRules(type) {
            return [].concat.apply([], this.accounts.map((ac) => {
                if (
                    (ac.account.length && ac.isChecked)
                    || (ac.jujiao_account.length && ac.jujiao_isChecked && ac.jujiao_isShow)
                ) {
                    var rules = ac.rules;
                    var typeRule = rules && rules[type];
                    if (typeRule) {
                        return {
                            account: ac,
                            rule: typeRule
                        };
                    }
                }

                return [];
            }));
        },
        checkChooseOrNo(){
            console.log(this.new_video_tts_interface)
            var chooseAccountLanguage = this.accounts.reduce((a,b)=>{
                if(b.account){
                    b.account.forEach(c=>{
                        if(c.isChecked){
                            console.log(c)
                            a.push(...c.share_language)
                        }
                    })
                }
                return a;
            },[])
            chooseAccountLanguage = [...new Set(chooseAccountLanguage)]
            console.log(chooseAccountLanguage,'chooseAccountLanguage')
            if(chooseAccountLanguage.length>0){
                var displayLanguageId = this.new_video_tts_interface.reduce((a,b)=>{
                    chooseAccountLanguage.forEach(c=>{
                        if(b.language){
                            if(b.language.split('-')[0]==c.split('-')[0]){
                                a.push(b)
                            }
                        }
                        if(b.languageName=='字幕视频'||b.languageName=='默认视频'){
                            a.push(b)
                        }
                    })
                    return a;
                },[])
                this.share_video_tts_id_language = displayLanguageId.reduce((a,b)=>{
                    return a.push(b.id),a;
                },[])
                this.share_video_tts_id = [this.share_video_tts_id_language[0]];
                this.share_video_tts_id = this.share_video_tts_id_language.reduce((a,b)=>{
                    console.log(b)
                    if(this.share_video_tts_id.indexOf(b)>-1){
                        var index = this.share_video_tts_id.indexOf(b)
                        a.push(this.share_video_tts_id[index]);
                    }
                    return a;
                },[])
                console.log(this.share_video_tts_id_language[0],this.share_video_tts_id,'this.share_video_tts_id')
            }else{
                this.share_video_tts_id_language = [];
                this.share_video_tts_id = [];
            }
        },
        /* 下一步 */
        nextStep() {
            this.clickBody();
            if(this.new_video_tts_interface.length!=0&&this.optionType==1&&(this.share_video_tts_id.length==0||this.chooseCheckItem.length==0)){
                this.$message({
                    showClose: true,
                    message: '请选择选择分享语种或勾选账号',
                    type: 'warning',
                    duration: 3000,
                    offset: 100
                })
                return
            }
            function formatDuration(value) {
                if (value < 60) {
                    return value + ' 秒';
                }
                const mins = Math.floor(value / 60), secs = value % 60;
                return (secs ? [mins, '分', secs, '秒'] : [mins, '分钟']).join(' ');
            }
            let cms = this.cms;//是否分享到商品详情
            let cms_video = this.cms_video;//是否分享到全网通video
            let website = this.website;//是否分享到视频官网页面
            let release = this.release;//是否分享到社媒平台
            let site_id = this.checkSiteList;//勾选的全网通站点id
            let video2b = this.optionType == 5;
            let websiteCheckedKeys = this.$refs.WebSiteTree.getCheckedKeys();//视频官网对应的导航页id数组;
            this.newWebsiteCheckedKeys = websiteCheckedKeys
            let releaseList = this.accounts;//社媒平台账号列表
            console.log('type',this.type)
            if (this.type == 3) {
                if (release || website || cms_video) {
                    let account = [];//勾选账号列表

                    let hasRelease = false;//有选择社媒平台
                    let accountResult = [];//账号勾选判断
                    for (let i = 0; i < releaseList.length; i++) {//遍历社媒平台账号列表
                        let release_item = releaseList[i];
                        hasRelease = hasRelease || release_item.isChecked;//至少有一个选中则为true
                        let accounts = release_item.account;
                        var params_release = JSON.parse(JSON.stringify(release_item));//copy一份平台数据
                        params_release.account = [];//清空原账号列表
                        if (release_item.isChecked) {//社媒已勾选
                            let hasAccount = false;//有勾选账号
                            for (let j = 0; j < accounts.length; j++) {
                                let account_item = accounts[j];
                                hasAccount = hasAccount || (account_item.isChecked && account_item.status == 1);//至少勾选一个正常常账号
                                if (account_item.isChecked && account_item.status == 1) {
                                    params_release.account.push(account_item);//保存勾选的账号
                                }
                            }
                            accountResult.push({ hasAccount, name: release_item.name });//保存判断信息
                            account.push(params_release);//保存平台账号参数
                        }
                    }
                    if (release) {//有勾选社媒发布判断是否有选账号
                        if (!hasRelease) {//未有勾选的社媒平台
                            this.$message({
                                showClose: true,
                                message: '请选择要分享的社媒平台',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            })
                            return;
                        }
                        let result = true;
                        let names = [];
                        for (let k = 0; k < accountResult.length; k++) {
                            result = result && accountResult[k].hasAccount
                            if (!accountResult[k].hasAccount) {
                                names.push(accountResult[k].name)
                            }
                        }
                        if (!result) {//选社媒平台下有未勾选的账号
                            this.$message({
                                showClose: true,
                                message: '请勾选' + names[0] + '平台下您要分享的账号',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            })
                            return;
                        }
                    }
                    if (website) {//发布到视频官网有勾选
                        if (websiteCheckedKeys.length == 0) {
                            this.$message({
                                showClose: true,
                                message: '请选择视频官网分类',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            });
                            return;
                        }
                    }
                    if (cms_video) {//发布到全网通video有勾选
                        if (site_id.length == 0) {
                            this.$message({
                                showClose: true,
                                message: '请选择全网通站点',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            });
                            return;
                        }
                    }
                }
                this.tdkList = [];
                let obj = {
                    title: this.params[0].title,
                    keywords: this.params[0].keywords,
                    desc: this.params[0].desc,
                }
                this.tdkList.push(obj)
                this.isTDKstep = true;
                this.dialog_title = '检查分享TDK'
                let id = [];
                let params = this.params;
                for (let j = 0; j < params.length; j++) {
                    id.push(params[j].id)
                }
                this.getVideoTDK(id[0]);
                return;
            }
            if (this.type != 3) {
                if (!(cms || release || website || cms_video || video2b)) {
                    if (this.optionType > 1) {
                        this.$message({
                            showClose: true,
                            message: '请选择分享方式',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        });
                        return;
                    } else {
                        this.$message({
                            showClose: true,
                            message: '请选择分享的社媒平台及账号',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        });
                        return;
                    }

                }
                else {
                    var platform = [];
                    if (cms) {
                        platform.push(2)
                    }
                    if (release) {
                        platform.push(3)
                    }
                    if (website) {
                        platform.push(4)
                    }
                    if (cms_video) {
                        platform.push(5)
                    }
                    if (video2b) {
                        platform.push(8)
                    }
                    if (platform.length == 0 && this.type == 3) {//当单个视频编辑 未选任何分享时，仅生成
                        platform.push(0)
                    }

                    // console.log('确认',this.platform,this.accounts)
                    // let platform = this.platform;//发布方式 0仅生成  1 全部 2全网通详情 3 仅社媒 4视频官网 5全网通video  6小渔夫video
                    my_self_logs('社媒账号列表', releaseList, platform)
                    let content = this.text;//社媒帖子文案
                    let account = [];//勾选账号列表
                    if (platform.length == 0) {
                        this.$message({
                            showClose: true,
                            message: '请选择分享方式',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        });
                        return;
                    }
                    if (video2b) {
                        if (!this.v2bActive.category_id) {
                            this.$message({
                                showClose: true,
                                message: '请选择需要分享的分类',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            });
                            return;
                        }
                    }
                    let hasRelease = false;//有选择社媒平台
                    let accountResult = [];//账号勾选判断
                    for (let i = 0; i < releaseList.length; i++) {//遍历社媒平台账号列表
                        let release_item = releaseList[i];
                        hasRelease = hasRelease || release_item.isChecked;//至少有一个选中则为true
                        let accounts = release_item.account;
                        var params_release = JSON.parse(JSON.stringify(release_item));//copy一份平台数据
                        params_release.account = [];//清空原账号列表
                        if (release_item.isChecked) {//社媒已勾选
                            let hasAccount = false;//有勾选账号
                            for (let j = 0; j < accounts.length; j++) {
                                let account_item = accounts[j];
                                hasAccount = hasAccount || (account_item.isChecked && account_item.status == 1);//至少勾选一个正常常账号
                                if (account_item.isChecked && account_item.status == 1) {
                                    params_release.account.push(account_item);//保存勾选的账号
                                }
                            }
                            if (params_release.industry_id) {
                                hasAccount = true;
                            }
                            accountResult.push({
                                hasAccount,
                                name: release_item.name,
                                media: release_item.media,
                                icon: release_item.icon,
                                rules: release_item.rules
                            });//保存判断信息
                            account.push(params_release);//保存平台账号参数
                        }
                    }
                    my_self_logs('账号勾选情况', accountResult)
                    if (release) {//有勾选社媒发布判断是否有选账号
                        if (!hasRelease) {//未有勾选的社媒平台
                            this.$message({
                                showClose: true,
                                message: '请选择要分享的社媒平台',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            })
                            return;
                        }
                        let result = true;
                        let names = [];
                        var accountLookup = {};
                        for (let k = 0; k < accountResult.length; k++) {
                            accountLookup[accountResult[k].name] = 1;
                            result = result && accountResult[k].hasAccount
                            if (!accountResult[k].hasAccount) {
                                names.push(accountResult[k].name)
                            }
                        }

                        var hasInstagram = !!accountLookup.Instagram;
                        var curRule = {};
                        var errorText;

                        var selectedAccounts = [];

                        accountResult.forEach(ac => {
                            if (ac.hasAccount) {
                                selectedAccounts.push(ac);
                                const rule = ac.rules;
                                ['min', 'max', 'minDuration', 'maxDuration'].forEach((t) => {
                                    const prefix = t.slice(0, 3);
                                    let next;
                                    if (t in rule.video) {
                                        if (!(t in curRule)) {
                                            next = true;
                                        } else {
                                            if (prefix === 'min') {
                                                if (rule.video[t] > curRule[t].value) {
                                                    next = true;
                                                }
                                            } else {
                                                if (rule.video[t] < curRule[t].value) {
                                                    next = true;
                                                }
                                            }
                                        }
                                    }
                                    if (next) {
                                        curRule[t] = {
                                            name: ac.name,
                                            value: rule.video[t]
                                        };
                                    }
                                });
                            }
                        });

                        this.previewAccounts = selectedAccounts;

                        // console.log(accountResult);

                        if (!result) {//选社媒平台下有未勾选的账号
                            this.$message({
                                showClose: true,
                                message: '请勾选' + names[0] + '平台下您要分享的账号',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            })
                            return;
                        }
                        console.log(this.params)
                        // 视频时长
                        if (this.params[0].duration) {
                            let vid_dration = this.params[0].duration.split(':');
                            let duration = vid_dration[0] * 60 + (+vid_dration[1]);
                            if (curRule.minDuration) {
                                if (duration < curRule.minDuration.value) {
                                    errorText = [
                                        '分享到',
                                        curRule.minDuration.name,
                                        '平台的视频时长必须大于',
                                        formatDuration(curRule.minDuration.value)
                                    ].join(' ');
                                }
                            }

                            if (curRule.maxDuration) {
                                if (duration > curRule.maxDuration.value) {
                                    errorText = [
                                        '分享到',
                                        curRule.maxDuration.name,
                                        '平台的视频时长必须小于',
                                        formatDuration(curRule.maxDuration.value)
                                    ].join(' ');
                                }
                            }
                        }
                        // 视频大小
                        let shape = this.share_video_shape
                        if (shape) {
                            if (curRule.min) {
                                if (shape < curRule.min.value) {
                                    errorText = ['分享到', curRule.min.name, '平台的视频大小必须大于', formatSize(curRule.min.value)].join(' ');
                                }
                            }

                            if (curRule.max) {
                                if (shape > curRule.max.value) {
                                    errorText = ['分享到', curRule.max.name, '平台的视频大小必须小于', formatSize(curRule.max.value)].join(' ');
                                }
                            }
                        }
                        // 视频比例  1（16:9）2（1:1）3（9:16）
                        // let specs = this.specs
                        // if (specs) {
                        //     if (hasInstagram && specs == 2) {
                        //         errorText = '分享到Instagram平台的视频比例必须为9:16或16:9';
                        //     }
                        // }
                        if (errorText) {
                            this.$message({
                                message: errorText,
                                type: 'warning',
                                showClose: true,
                                duration: 3000,
                                offset: 100
                            });
                            return;
                        }
                        // 设置各大平台标题最大字符（取最小）
                        var titleRules = this.getAccountRules('title');
                        var minTitleLimit = Math.min.apply(Math, titleRules.map(tr => tr.rule.limit || Infinity));
                        console.log('minTitleLimit',minTitleLimit)
                        if (!titleRules.some(tr => {
                            if (tr.rule.limit === minTitleLimit) {
                                this.tdkTitleRule = { // TDK标题规则
                                    tip: `(请输入少于 ${minTitleLimit} 字符，标题可采用“关键词+视频内容主题+品牌+型号”的方式编写)`,
                                    msg: `分享到 ${tr.account.name} 平台的标题字数限制在 ${minTitleLimit} 个字符`,
                                    maxLength: minTitleLimit
                                }
                                return true;
                            }
                            return false;
                        })) {
                            this.tdkTitleRule = { // TDK标题规则
                                tip: "(标题可采用“关键词+视频内容主题+品牌+型号”的方式编写)",
                                maxLength: minTitleLimit
                            }
                        }
                        console.log('tdkTitleRule', this.tdkTitleRule)
                        // 设置各大平台关键词最大字符（取最小）
                        var keywordRules = this.getAccountRules('keywords');
                        var keywordLimit = Math.min.apply(Math, keywordRules.map(tr => tr.rule.limit || Infinity));
                        if (!keywordRules.some(tr => {
                            if (tr.rule.limit === keywordLimit) {
                                this.tdkKeywordRule = { // TDK标题规则
                                    tip: "(关键词请用英文逗号','隔开)",
                                    msg: `分享到 ${tr.account.name} 平台的关键词字数限制在 ${keywordLimit} 个字符`,
                                    maxLength: keywordLimit
                                }
                                return true;
                            }
                            return false;
                        })) {
                            this.tdkKeywordRule = {
                                tip: "(关键词请用英文逗号','隔开)"
                            }
                        }

                        // 设置各大平台描述最大字符（取最小）
                        var descRules = this.getAccountRules('description');
                        var descLimit = Math.min.apply(Math, descRules.map(tr => tr.rule.limit || Infinity));
                        console.log('logging');
                        console.log(descRules);
                        if (!descRules.some(tr => {
                            if (tr.rule.limit === descLimit) {
                                this.tdkDesRule = { // TDK标题规则
                                    msg: `分享到 ${tr.account.name} 平台的描述字数限制在 ${descLimit} 个字符`,
                                    tip: `(请输入少于 ${descLimit} 字符，描述可以包含视频内容的概述和匹配视频内容的关键词)`,
                                    maxLength: descLimit
                                }
                                return true;
                            }
                            return false;
                        })) {
                            this.tdkDesRule = {
                                tip: "(请输入少于5000字符，描述可以包含视频内容的概述和匹配视频内容的关键词)",
                                maxLength: 5000
                            }
                        }
                    }
                    if (website) {//发布到视频官网有勾选
                        if (websiteCheckedKeys.length == 0) {
                            this.$message({
                                showClose: true,
                                message: '请选择视频官网分类',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            });
                            return;
                        }
                    }
                    if (cms_video) {//发布到全网通video有勾选
                        if (site_id.length == 0) {
                            this.$message({
                                showClose: true,
                                message: '请选择全网通站点',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            });
                            return;
                        }
                    }
                }
            }
            let id = [];
            let params = this.params;
            console.log('ishare_material', this.ishare_material);
            if (this.ishare_material == 'material') {
                console.log(this.params)
                console.log('material   123123');
                this.getmaterialTDK(this.params[0].id);
            } else {
                for (let j = 0; j < params.length; j++) {
                    id.push(params[j].id)
                }
                if(this.origin!='moveHouse') {
                    this.getVideoTDK(id[0]);
                } else {
                    this.getMoveHouseVideoTDK(id[0]);
                }
            }

        },
        prevStep() {
            this.clickBody()
            if (!this.isTDKstep) {
                this.handleSelectWebsiteTab({ name: 'websitePageTab' })
                this.contentClone = true;
                this.firstStep = true;
                this.optionType = '';
                this.cms = false;//是否分享到商品详情
                this.cms_video = false;//是否分享到全网通video
                this.fish_video = 'list';//是否分享到小渔夫video
                this.release = false;//是否分享到社媒平台
                this.$refs.WebSiteTree.setCheckedKeys([])
                this.website = false;//是否分享到视频官网页面
                this.website_resource_library = false;//是否分享到视频官网资源库
                this.checkSiteList = [];
                this.checkFishSiteList = [];
                let list = this.accounts;
                for (let i = 0; i < list.length; i++) {//遍历初始化所有选项未未选
                    let account = list[i].account;
                    this.$set(this.accounts[i], 'isChecked', false);
                    for (let j = 0; j < account.length; j++) {
                        this.$set(this.accounts[i].account[j], 'isChecked', false);
                    }
                    this.$set(this.accounts[i], 'jujiao_isChecked', false);
                }
                if (this.current_release_index >= 0) {
                    this.jujiaoChange(false)
                }
            } else if (this.cropperShowing) {
                this.cropperShowing = false;
            } else if (this.previewVisible) {
                this.previewVisible = false;
            } else {
                this.isTDKstep = false;
                this.dialog_title = '视频分享';
            }

        },
        /* 懒加载分类 */
        loadWebsite(node, resolve) {
            if (!getCookie('token')) {
                // console.log('没有登录')
                window.location.href = '/login'
                return;
            }
            my_self_logs('节点数据', node.data);
            var self = this;
            var token = get_cookie_token();
            let parent_id = 0;
            if (node.data) {
                parent_id = node.data.id;
            }
            if (node.level === 0) { //首次加载
                self.website_loading = true;
                $.ajax({
                    url: my_video_request_api.website_nav,
                    type: 'POST',
                    data: { parent_id },
                    dataType: "json",
                    headers: {
                        'Authorization': token
                    },
                    success: function (res) {
                        self.website_loading = false;
                        if (res.status === 1) {
                            my_self_logs('获取视频官网导航分类', res)
                            let data = res.data;
                            console.log(data,'datadatadatadata')
                            let arr = [];
                            for (let i = 0; i < data.length; i++) {
                                let item = data[i]
                                item.label = data[i].name;
                                item.children = [];
                                arr.push(item);
                            }
                            self.website_list = arr;
                            return resolve(arr);
                        } else if (res.status === 0) {
                            self.hasWebsite = false;
                            return resolve([]);
                        } else if (res.status === 10001) {
                            self.$message({
                                showClose: true,
                                message: res.msg,
                                type: 'error',
                                duration: 3000,
                                offset: 100
                            })
                            document.cookie = "token="
                            window.location.href = '/login';
                            return;
                        }
                    },
                    fail: function (err) {

                    }
                })
            }
            if (node.level > 0) {
                self.website_loading = true;
                $.ajax({
                    url: my_video_request_api.website_nav,
                    type: 'POST',
                    data: { parent_id },
                    dataType: "json",
                    headers: {
                        'Authorization': token
                    },
                    success: function (res) {
                        self.website_loading = false;
                        if (res.status === 1) {
                            my_self_logs('获取视频官网导航分类', res)
                            let data = res.data;
                            let arr = [];
                            for (let i = 0; i < data.length; i++) {
                                let item = data[i]
                                item.label = data[i].name;
                                item.children = [];
                                arr.push(item);
                            }
                            return resolve(arr);
                        }
                    },
                    fail: function (err) {

                    }
                })
            }
        },
        /* 商品详情发布方式 */
        cmsChangeHandler() {
            this.cms = !this.cms;
        },
        // 视频分享到视频官网页面or到视频官网资源库的tab切换
        handleSelectWebsiteTab(tab, event) {
            this.activeWebsiteIndexTab = tab.name;
            this.setTtsTypes()
            if (this.activeWebsiteIndexTab == 'websitePageTab') {
                //初始化 切换到 视频分享到视频官网页面
                this.hasWebsite = true;
                this.website = true;

                //清空 视频分享到视频官网资源库的数据
                this.isActiveWebsiteResourceLibrary = false;
                this.website_resource_library = false;
            } else if (this.activeWebsiteIndexTab == 'websiteResourceLibraryTab') {
                //切换到 视频分享到视频官网资源库
                this.isActiveWebsiteResourceLibrary = true;
                this.website_resource_library = true;

                //清空 视频分享到视频官网页面的数据
                this.hasWebsite = false;
                this.website = false;
                this.$refs.WebSiteTree.setCheckedKeys([]);
            }
        },
        /* 视频官网资源库 手动选中 */
        websiteResourceLibraryChangeHandler() {
            this.website_resource_library = !this.website_resource_library;
        },
        /* 获取所有树形结构 */
        getALlTree(parent, level) {
            // console.log(parent,level);

            if (level > 0) {//不是最顶级分类
                let top_parent = parent.parent
                let parent_level = top_parent.level;
                return this.getALlTree(top_parent, parent_level)
            } else if (level == 0) {//顶级分类
                var list = parent.childNodes;
                var arr = [];
                // console.log(list);
                for (let i = 0; i < list.length; i++) {//遍历顶级分类
                    let top_leavel = list[i].data;
                    let top_children = list[i].childNodes;
                    // console.log('顶级分类',top_leavel.name,'子级',top_children);

                    if (top_children.length > 0) {//顶级分类有子级
                        let child_1_data = [];
                        for (let j = 0; j < top_children.length; j++) {//遍历顶级分类子级
                            let middle_leavel = top_children[j].data;
                            let middle_children = top_children[j].childNodes;
                            // console.log('子级分类',middle_leavel.name,'孙级',middle_children);
                            if (middle_children.length > 0) {//如果子级有孙级
                                let child_2_data = [];
                                for (let k = 0; k < middle_children.length; k++) {//遍历孙级
                                    let last_leavel = middle_children[k].data;
                                    child_2_data.push(last_leavel)
                                    // console.log('孙级分类',last_leavel.name);
                                }
                                middle_leavel.children = child_2_data
                            }
                            child_1_data.push(middle_leavel)
                        }
                        top_leavel.children = child_1_data
                    }
                    arr.push(top_leavel)
                }
                // console.log('getALlTree',arr);
                return arr;
            }
        },
        /* 视频官网分类选择事件 */
        checkGroupNode: function (ev, obj) {
            // TODO: multiple
            let checkedKeys = obj.checkedKeys;
            const tree = this.$refs.WebSiteTree;

            if (checkedKeys.some(k => k === ev.id)) {
                console.log('checking');
                let node = tree.getNode(ev.id);
                while (node.level > 1) {
                    node = node.parent;
                }
                const keys = checkedKeys.filter(k => {
                    let curNode = tree.getNode(k);
                    while (curNode.level > 1) {
                        curNode = curNode.parent;
                    }
                    return curNode.id === node.id;
                });

                checkedKeys = keys;
                tree.setCheckedKeys(keys);
            } else {
                console.log('unchecking');
            }
            this.website = !!checkedKeys.length;
            console.log(checkedKeys);

            const navIds = [];
            const labels = [];

            checkedKeys.forEach(key => {
                let root = tree.getNode(key);
                if (root) {
                    labels.push(root.label);

                    while (root.level > 1) {
                        root = root.parent;
                    }

                    navIds.push([root.key].concat(key === root.key ? 0 : key).join(','));
                }
            });

            console.log(navIds);
            this.websiteNavigationIds = navIds;
            this.websiteShareMsgs = labels.join(',');
        },
        /* 全网通是否分享变更 */
        shareCmsVideoChange(e) {
            if (!e) {
                this.checkSiteList = [];
            } else if (e && this.checkSiteList.length == 0) {
                for (let i = 0; i < this.siteList.length; i++) {
                    this.checkSiteList.push(this.siteList[i].site_id)
                }
                this.optionType = 3;
            }
        },
        /* 全网通站点变更 */
        cmsVideoChange(e) {
            if (e.length > 0) {
                this.cms_video = true;
            } else {
                this.cms_video = false;
            }
        },
        /* 小渔夫是否分享变更 */
        shareFishVideoChange(e) {
            if (!e) {
                this.checkFishSiteList = [];
            } else if (e && this.checkFishSiteList.length == 0) {
                for (let i = 0; i < this.fishSiteList.length; i++) {
                    this.checkFishSiteList.push(this.fishSiteList[i].id)
                }
                this.optionType = 4;
                console.log(456, this.checkFishSiteList)
            }
        },
        /* 关闭弹窗 */
        closeDialog() {
            this.handleSelectWebsiteTab({ name: 'websitePageTab' })
            this.$refs.WebSiteTree.setCheckedKeys([])
            this.cms_video = false;
            this.cms = false;
            this.fish_video = 'list';
            this.release = false;
            this.website = false;
            this.website_resource_library = false;
            this.optionType = undefined;
            this.website_nav = undefined;
            this.checkSiteList = [];
            this.checkFishSiteList = [];
            this.isLoading = false;
            this.isTDKstep = false;
            this.platform = '';
            this.text = '';
            let list = this.accounts;
            for (let i = 0; i < list.length; i++) {//遍历初始化所有选项未未选
                let account = list[i].account;
                this.$set(this.accounts[i], 'isChecked', false);
                for (let j = 0; j < account.length; j++) {
                    this.$set(this.accounts[i].account[j], 'isChecked', false);
                }
            }
            this.$emit('close-handler');
        },
        debounce(fn, delay) {
          var args = arguments;
          var that = this;
          return function () {
            if (that.timer) {
              clearTimeout(that.timer);
            }
            that.timer = setTimeout(function () {
                  fn.call(that, args);
            }, delay);
          };
        },
        setTdkDataList(e){
            if(e.length>0){
                if (this.shareTimeType == 3) {
                    e.forEach(i=>{
                        i.time_zone_id = this.shareTimeList[i.media].time_zone_id;
                        i.plan_time = this.shareTimeList[i.media].time;
                    })
                }
                if (this.shareTimeType == 2) {
                    e.forEach(i=>{
                        i.time_zone_id = this.timeZone;
                        i.plan_time = this.shareTime || '';
                    })
                }
            }
            var data = {
                id:this.sharedialog_video_id,
                mediaTdk:e,
                oauth_id:this.newnewVideoTTs.length>0?this.newnewVideoTTs[0].ids.join(','):0,
                share_time_mode:this.shareTimeType
            }
            console.log(this.ishare_material)
            console.log(data)
            console.log('setTdkDataList',data)
            if(this.ishare_material == 'material') {
                // 后端说要加
                data.classify = 2
            }
            this.seniorData = data;
        },
        async seniorUpdata(){
            var data = this.seniorData;
            const res = await my_http_ajax('/api/share/intellect-video','post',data,this);
            console.log('seniorUpdataRes', res)
            return res
        },
        //没高级模式提交
        async ordinaryUpdata(){
                const ids = []
                this.chooseCheckItem.forEach(item =>{
                    if(item.account.length){
                        item.account.forEach(acc =>{
                            if(acc.isChecked){
                                ids.push(acc.id)
                            }
                        })

                    }
                })

                var _t = this;
                let id = this.sharedialog_video_id;
                let intervalTime = this.new_video_tts_interface.length>1?this.sharingInterval:0;
                let newdata = this.newnewVideoTTs.reduce((a,b)=>{
                    this.newTdk.map(i=>{
                        if(i.id==b.id){
                            a.push({
                                ttsId:i.id,
                                // o_id:b.ids,
                                o_id: ids,
                                title:_t.tdkList[0] && _t.tdkList[0].title,
                                keywords: _t.tdkList[0] && _t.tdkList[0].keywords, //关键词
                                desc:_t.tdkList[0] && _t.tdkList[0].desc,   //描述
                                translate: !!i.translate?1:0
                            })
                        }
                    })
                    return a;
                },[])
                let data = {
                    id:id,
                    intervalTime:intervalTime,
                    languageShare:newdata
                }
                var media = [];
                if (this.shareTimeType == 3) {
                    media = this.chooseCheckItem.reduce((b,i)=>{
                        b.push({
                            media:i.media,
                            time_zone_id:this.shareTimeList[i.media].time_zone_id,
                            plan_time:this.shareTimeList[i.media].time
                        })
                        return b;
                    },[])
                    data.media = media;
                }
                if (this.shareTimeType == 2) {
                     media = this.chooseCheckItem.reduce((b,i)=>{
                        b.push({
                            media:i.media,
                            time_zone_id:this.timeZone,
                            plan_time:data.plan_time = this.shareTime || ''
                        })
                        return b;
                    },[])
                    data.media = media;
                }
                // 这里加参数
                if (this.hasYouTube) {
                  data.privacyStatus = this.privacyStatus
                }
                await my_http_ajax('/api/share/media-video','post',data,this);
        },
        /* 确认事件 */
        async confrimHandler() {
            // 新增
            console.log('~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~',this.optionType,this.share_video_tts.length)
            if (this.optionType === 33) {
              this.btnLoading1 = true
              const env = await this.getFishEnv()
              this.btnLoading1 = false
              const videoList = this.params[0].ttsVideo
              const video = videoList.find(i => i.id === this.share_video_tts_id[0]) || videoList[0]
              console.log('video', video)
              if (env && video) {
                var url = `${env.domain}/social-media/release/video-sharing?auth_code=${env.auth_code}&client_id=${env.tenant_account_id}`
                // const url = `http://social.dweyes.cn/social-media/release/video-sharing?auth_code=${env.auth_code}&client_id=${env.tenant_account_id}`
                // http://social.dweyes.cn/
                const videoUrl = encodeURIComponent(video.wurl || video.url)
                const thumbnail = encodeURIComponent(video.thumbnail)
                console.log(`${url}&videourl=${videoUrl}&thumbnail=${thumbnail}`)
                const a = document.createElement('a')
                a.setAttribute('href', `${url}&videourl=${videoUrl}&thumbnail=${thumbnail}`)
                a.setAttribute('target', '_blank')
                a.click()
                this.closeDialog()
              } else {
                this.$message({
                  message: '分享失败',
                  type: 'error',
                  duration: '2000'
                })
              }
              return
            }
            // 分享到小渔夫素材库
            if(this.optionType == 4 && this.fish_video==='lib' && this.origin) {
                let type
                if(this.origin == 'myVideo') {
                    type = 1
                }
                if(this.origin == 'material') {
                    type = 2
                }
                if(this.origin == 'moveHouse') {
                    type = 3
                }
                if(this.fishsiteCategory.category.length == 0) {
                    this.$message.warning('请选择小渔夫站点')
                    return
                }
                const params = {
                    id: this.sharedialog_video_id,
                    category: this.fishsiteCategory.category,
                    type
                }
                if (type == 1) {
                    if(this.shareTtsType == 0 ) {
                        params.tts_video_share_type = 1
                    }
                    if(this.shareTtsType == 1 ) {
                        params.tts_video_share_type = 3
                    }
                    if (this.shareTtsType == 2) {
                        params.tts_video_share_type = 3
                    }

                }
                console.log('confrimHandler 小渔夫素材库', params);

                const res = await  $.ajax({
                    method: 'POST',
                    url: '/api/fish/share-material',
                    headers: {
                        Authorization: get_cookie_token(),
                        'Content-Type': 'applicatin/json'
                    },
                    data:JSON.stringify(params)
                }).catch(err => {
                    console.log('err',err)
                })
                console.log('res', res);
                if(res.status == 1) {
                    let params;
                    if (this.ishare_material == 'material') {
                        params = localStorage.getItem('material_data');
                    } else{
                        params = store.getters.get_video_list_params();
                    }
                    this.$emit('refresh', params)
                    this.closeDialog();
                    this.$message.success('提交成功！视频正在分享中，请稍后查看分享结果!')
                } else {
                    res.msg && this.$message.warning(res.msg)
                }
                return
            }
            if (this.optionType==1 && this.origin =='moveHouse') {
                const _t = this
                websiteCheckedKeys =this.accounts.reduce((a,b)=>{
                    if(b.isChecked){
                        b.account.forEach((i)=>{
                            if(i.isChecked){
                                a.push(i.id)
                            }
                        })
                    }
                    return a;
                },[])
                var token = get_cookie_token();
                var data = {
                    reptile_list_id:_t.tdkList[0].id,   //搬家产品ID
                    o_id:websiteCheckedKeys,                         //社媒账号ID
                    title:_t.tdkList[0].title,                       //标题
                    keywords:_t.tdkList[0].keywords,                 //关键词
                    desc:_t.tdkList[0].description,                         //描述
                    status:_t.shareTimeType,                     //分享类型
                    time_zone_id:_t.shareTimeType==3?_t.shareTimeTimeZoneId:_t.timeZone,          //分享区域或国家ID
                    plan_time:_t.shareTimeType==3?_t.shareTimeListTime:_t.shareTime            //设置分享的时间
                }
                if (!data.title.length) {
                    this.$message({
                        showClose: true,
                        message: '标题不能为空',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    });
                    this.isLoading = false;
                    return
                } else if (data.title.length > this.tdkTitleRule.maxLength) {
                    this.$message({
                        showClose: true,
                        message: this.tdkTitleRule.msg || '标题字数限制在' + this.tdkTitleRule.maxLength + '字内',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    });
                    this.isLoading = false;
                    return
                } else if (this.tdkKeywordRule.maxLength && data.keywords && (this.keywordsLength(data?.keywords) > this.tdkKeywordRule.maxLength)) {
                    this.$message({
                        showClose: true,
                        message: this.tdkKeywordRule.msg || '关键词字数限制在' + this.tdkKeywordRule.maxLength + '字内',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    });
                    this.isLoading = false;
                    return
                } else if (data.desc && (data.desc.length > this.tdkDesRule.maxLength)) {
                    this.$message({
                        showClose: true,
                        message: this.tdkDesRule.msg || '描述内容字数限制在' + this.tdkDesRule.maxLength + '字内',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    });
                    this.isLoading = false;
                    return
                }
                $.ajax({
                    url: '/api/share/oauth-reptile-video',
                    type: "POST",
                    dataType: 'json',
                    data: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token,
                    },
                    success: function (res) {
                        if(res.status==1){
                            _t.$message({
                                showClose: true,
                                message: '提交成功！视频正在分享中，请稍后查看分享结果!',
                                type: 'success',
                                duration: 3000,
                                offset: 100
                            })
                            _t.$emit('refresh');
                            _t.closeDialog();
                        }
                        _t.isLoading = false;
                    }
                })
                return
            }
            if(this.advancedSwitch&&!this.has_new_video_tts){
                this.isLoading = true;
                try{
                    const res = await this.seniorUpdata();
                    this.isLoading = false;
                    console.log('高级res', res)
                    if (res) {
                        let params;
                        if (this.ishare_material == 'material') {
                            params = localStorage.getItem('material_data');
                        } else{
                            params = store.getters.get_video_list_params();
                        }
                    // console.log(params)
                    this.$emit('refresh', params);//刷新列表数据
                        // this.$emit('refresh')
                        this.closeDialog();
                        this.$message.success('分享成功')
                    }
                }catch(e){
                    console.log(e)
                    this.isLoading = false;
                }
                // this.$emit('refresh')
                // this.closeDialog();

                return
            }
            if(this.optionType==1&&this.share_video_tts.length){
                this.isLoading = true;
                try{
                    await this.ordinaryUpdata();
                }catch(e){
                    console.log(e)
                }
                this.$emit('refresh')
                this.closeDialog();
                this.isLoading = false;
                return
            }
            // 新增end
            if (this.defaultTdk) {
                this.$emit('reshare', this.tdkList[0]);
                return;
            }
            const tree = this.$refs.WebSiteTree;
            let cms = this.cms;//是否分享到商品详情
            let cms_video = this.cms_video;//是否分享到全网通video
            let hasFishVideo = this.checkFishSiteList && this.checkFishSiteList.length;//是否分享到小渔夫video
            let fish_video = this.fish_video;
            let website = this.website;//是否分享到视频官网页面
            let website_resource_library = this.website_resource_library;//是否分享到视频官网资源库
            let release = this.release;//是否分享到社媒平台
            var site_id = '';

            if (this.optionType == 3) {
                //全网通
                site_id = this.checkSiteList;
            } else {
                //小渔夫
                site_id = this.checkFishSiteList;
            }
            let websiteCheckedKeys = this.newWebsiteCheckedKeys;//视频官网对应的导航页id数组;
            let websiteNavigationIds = this.websiteNavigationIds;//顶级导航id
            var platform = [];
            if (cms) {
                platform.push(2)
            }
            if (website) {
                platform.push(4)
            }
            if (website_resource_library) {
                platform.push(7)
            }
            if (cms_video) {
                platform.push(5)
            }
            if (hasFishVideo) {
                platform.push(6)
            }
            if (platform.length == 0 && this.type == 3) {//当单个视频编辑 未选任何分享是，仅生成
                platform.push(0)
            }
            // if(this.optionType == 5) {
            //     platform.push(8)
            // }
            // console.log('确认',this.platform,this.accounts)
            // let platform = this.platform;//发布方式 0仅生成  1 全部 2全网通详情 3 仅社媒 4视频官网 5全网通video  6小渔夫video 7视频官网资源库 8video2b
            let releaseList = this.accounts;//社媒平台账号列表
            console.log('社媒账号列表', releaseList, platform)
            let content = this.text;//社媒帖子文案
            let account = [];//勾选账号列表
            this.isLoading = true;
            if (platform.length == 0 && !release) { // detect release later
                this.$message({
                    showClose: true,
                    message: '请选择分享方式',
                    type: 'warning',
                    duration: 3000,
                    offset: 100
                });
                this.isLoading = false;
                return;
            }
            let hasRelease = false;//有选择社媒平台
            let hasVideo2bRelease = false;
            let accountResult = [];//账号勾选判断
            let hasYouTube = false; // 有选择youtube
            releaseList.forEach((release_item) => {//遍历社媒平台账号列表
                let accounts = release_item.account;
                var params_release = JSON.parse(JSON.stringify(release_item));//copy一份平台数据
                params_release.account = [];//清空原账号列表
                if (release_item.isChecked) {
                    //社媒已勾选
                    // but it could be Video2B
                    if (release_item.media === 14) {
                        console.log('checked Video2B');
                        hasVideo2bRelease = true;
                        platform.push(8);
                    } else {
                        hasRelease = true;
                        if (release_item.name == 'YouTube') {
                            hasYouTube = true
                        }
                        let hasAccount = false;//有勾选账号
                        for (let j = 0; j < accounts.length; j++) {
                            let account_item = accounts[j];
                            hasAccount = hasAccount || (account_item.isChecked && account_item.status == 1);//至少勾选一个正常常账号
                            if (account_item.isChecked && account_item.status == 1) {
                                params_release.account.push(account_item);//保存勾选的账号
                            }
                        }
                        if (params_release.industry_id) {
                            hasAccount = hasAccount || true;
                        }
                        accountResult.push({ hasAccount, name: release_item.name });//保存判断信息
                        account.push(params_release);//保存平台账号参数
                    }
                }
            });
            my_self_logs('账号勾选情况', accountResult)
            if (release) {//有勾选社媒发布判断是否有选账号
                if (hasRelease) {
                    platform.push(3);
                    let result = true;
                    let names = [];
                    for (let k = 0; k < accountResult.length; k++) {
                        result = result && accountResult[k].hasAccount
                        if (!accountResult[k].hasAccount) {
                            names.push(accountResult[k].name)
                        }
                    }
                    if (!result) {//选社媒平台下有未勾选的账号
                        this.$message({
                            showClose: true,
                            message: '请勾选' + names[0] + '平台下您要分享的账号',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        })
                        this.isLoading = false;
                        return;
                    }
                } else if (!hasVideo2bRelease) {
                    //未有勾选的社媒平台
                    this.$message({
                        showClose: true,
                        message: '请选择要分享的社媒平台',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    })
                    this.isLoading = false;
                    return;
                }
            }
            if (website) {//发布到视频官网页面有勾选
                if (websiteCheckedKeys.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择视频官网分类',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    });
                    this.isLoading = false;
                    return;
                }
            }

            if (cms_video) {//发布到全网通video有勾选
                if (site_id.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择全网通站点',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    });
                    this.isLoading = false;
                    return;
                }
            }
            if (hasFishVideo) {//发布到小渔夫video有勾选
                if (site_id.length == 0) {
                    this.$message({
                        showClose: true,
                        message: '请选择小渔夫站点',
                        type: 'warning',
                        duration: 3000,
                        offset: 100
                    });
                    this.isLoading = false;
                    return;
                }
            }
            console.log('platform', platform)
            if (platform === 0) {
                account = []
            }
            // my_self_logs('请求的发布方式，平台账号参数',{account,platform,official_column,site_id,content,params:this.params})
            if (this.type == 1 || this.type == 4) {//分享 （单个分享和批量分享）
                let list = this.params;//当前选中的视频列表
                let arr = [];
                for (let i = 0; i < list.length; i++) {
                    arr.push(list[i].id);
                }
                let account_arr = [];
                for (let j = 0; j < account.length; j++) {
                    let platform_item = account[j];
                    /* 1（Twitter)2（Facebook）3（Youtube）4（Pinterest） */
                    let platform_accounts = platform_item.account;
                    console.log(platform_accounts,'platform_accounts')
                    for (let k = 0; k < platform_accounts.length; k++) {//用户个人社媒账号数据组装
                        let account_item_obj = {}
                        account_item_obj.name = platform_item.name;
                        account_item_obj.account_id = platform_accounts[k].id;
                        account_item_obj.account_name = platform_accounts[k].display_name;
                        account_item_obj.official_account_id = 0;
                        account_item_obj.industry_id = 0;
                        if (this.shareTimeType == 3) {
                            account_item_obj.time_zone_id = this.shareTimeList[platform_item.media].time_zone_id
                            account_item_obj.plan_time = this.shareTimeList[platform_item.media].time
                        }
                        account_arr[account_arr.length] = account_item_obj
                    }
                    if (platform_item.industry_id) {//聚焦社媒账号数据组装
                        let official_account_name = '聚焦官网账号';
                        let official_account_id;
                        platform_item.jujiao_account.forEach((jujiao_category) => {
                            if (jujiao_category.industry_id == platform_item.industry_id) {
                                official_account_id = jujiao_category.official_account_id
                            }
                        })
                        let official_item = {
                            name: platform_item.name,
                            account_id: 0,
                            official_account_id,
                            industry_id: platform_item.industry_id,
                            account_name: official_account_name,
                            share_time_mode: this.shareTimeType
                        }
                        if (this.shareTimeType == 3) {
                            official_item.time_zone_id = this.shareTimeList[platform_item.media].time_zone_id
                            official_item.plan_time = this.shareTimeList[platform_item.media].time
                        }
                        account_arr[account_arr.length] = official_item
                    }
                }
                let data = {
                    account: account_arr,
                    platform,
                    content,
                    navigation_ids: websiteNavigationIds,
                    site_id,
                    data: this.tdkList,
                    share_time_mode: this.shareTimeType
                }/* id:arr, */
                if (this.shareTimeType == 3 && hasVideo2bRelease) {
                    data.time_zone_id = this.shareTimeList[14].time_zone_id;
                    data.plan_time = this.shareTimeList[14].time;
                }
                if (website) {
                    data.classify_ai = websiteCheckedKeys;
                    if (this.share_video_tts_types.length) {
                        data.tts_video_share_type = this.shareTtsType;
                    } else if (this.params[0] && this.params[0].tts_id) {
                        data.tts_video_share_type = 3;
                    }

                    data.msg = this.websiteShareMsgs;
                }
                console.log('this.tdkList', this.tdkList)
                if (hasFishVideo) {
                    if (this.share_video_tts_types.length) {
                        data.tts_video_share_type = this.shareTtsType;
                    }
                    this.tdkList = [{
                        title: this.sharedialog_video_name,
                        keywords: '',
                        desc: '',
                        id: this.sharedialog_video_id,
                        classify: 2,
                        media: fish_video === 'lib' ? 8 : 0
                    }];
                    data.data = this.tdkList;
                    console.log('datadata', this.tdkList);
                }
                if (this.shareTimeType == 2 && this.optionType == 1) {
                    data.time_zone_id = this.timeZone;
                    if (this.shareTime) {
                        data.plan_time = this.shareTime || '';
                    }
                }
                if (this.share_video_tts_id) {
                    data.tts_id = this.share_video_tts_id
                }
                // if (hasVideo2bRelease || this.optionType == 5) {
                //     data.v2b_category_id = this.v2bActive.category_id
                // }
                my_self_logs('分享数据===', data)
                console.log(data)
                console.log(this.type);

                //分享到视频官网资源库使用单独的分享接口，其余情况都共用一个分享接口
                if (website_resource_library) {
                    //请求分享到视频官网资源库的分享接口(只传视频id)
                    this.share_video_to_website_resource_library_request(this.sharedialog_video_id);
                } else {
                    if (!data.data[0].title.length) {
                        this.$message({
                            showClose: true,
                            message: '标题不能为空',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        });
                        this.isLoading = false;
                        return
                    } else if (data.data[0].title.length > this.tdkTitleRule.maxLength) {
                        this.$message({
                            showClose: true,
                            message: this.tdkTitleRule.msg || '标题字数限制在' + this.tdkTitleRule.maxLength + '字内',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        });
                        this.isLoading = false;
                        return
                    } else if (this.tdkKeywordRule.maxLength && data.data[0].keywords && (this.keywordsLength(data.data[0].keywords) > this.tdkKeywordRule.maxLength)) {
                        this.$message({
                            showClose: true,
                            message: this.tdkKeywordRule.msg || '关键词字数限制在' + this.tdkKeywordRule.maxLength + '字内',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        });
                        this.isLoading = false;
                        return
                    } else if (data.data[0].desc && (data.data[0].desc.length > this.tdkDesRule.maxLength)) {
                        this.$message({
                            showClose: true,
                            message: this.tdkDesRule.msg || '描述内容字数限制在' + this.tdkDesRule.maxLength + '字内',
                            type: 'warning',
                            duration: 3000,
                            offset: 100
                        });
                        this.isLoading = false;
                        return
                    }
                    if (hasYouTube) {
                        // youtube关键词keyword增加重复词检测
                        if (data.data[0].keywords) {
                            let arr = data.data[0].keywords.split(',');
                            const obj = {};
                            const repeats = {};
                            arr.forEach(element => {
                                const k = element.replace(/\s+/g, ' ').replace(/(^\s*)|(\s*$)/g, "");
                                if (obj[k]) {
                                    repeats[k] = element;
                                }
                                obj[k] = 1;
                            });
                            const newArr = Object.keys(repeats).map(k => repeats[k]);
                            if (newArr.length) {
                                this.$message({
                                    showClose: true,
                                    message: `分享到 YouTube 的关键词存在重复: ${newArr.join(', ')}，请检查`,
                                    type: 'warning',
                                    duration: 3000,
                                    offset: 100
                                });
                                this.isLoading = false;
                                return
                            }
                        }
                        // youtube描述description增加禁用符号检测
                        if (data.data[0].desc.includes('<') || data.data[0].desc.includes('>')) {
                            this.$message({
                                showClose: true,
                                message: '分享到YouTube的描述内容不能包含符号"<>"，请检查',
                                type: 'warning',
                                duration: 3000,
                                offset: 100
                            });
                            this.isLoading = false;
                            return
                        }
                    }
                    //请求分享接口
                    if(this.optionType === 4 && this.origin == 'moveHouse'){
                        this.share_video_to_fish(data);
                    }else{
                        this.share_video_request(data);
                    }
                }

            } else if (this.type == 2) {//批量生成
                this.confrimCreate(platform, account);
            } else if (this.type == 3) {//单个视频生成
                let data = this.params[0];
                data.platform = platform;
                let platform_account = [];
                for (let j = 0; j < account.length; j++) {
                    let platform_item = account[j];
                    /* 1（Twitter)2（Facebook）3（Youtube）4（Pinterest） */
                    let array = platform_item.account;
                    for (k = 0; k < array.length; k++) {
                        let account_item_obj = {}
                        if (platform_item.media == 1) {
                            account_item_obj.name = "twitter"
                        } else if (platform_item.media == 2) {
                            account_item_obj.name = "facebook"
                        } else if (platform_item.media == 3) {
                            account_item_obj.name = "youtube"
                        } else if (platform_item.media == 4) {
                            account_item_obj.name = "pinterest"
                        } else if (platform_item.media == 5) {
                            account_item_obj.name = "linkedin"
                        } else if (platform_item.media == 6) {
                            account_item_obj.name = "vimeo"
                        } else if (platform_item.media == 9) {
                            account_item_obj.name = "VK"
                        } else if (platform_item.media == 10) {
                            account_item_obj.name = "Instagram"
                        } else if (platform_item.media == 11) {
                            account_item_obj.name = "Tumblr"
                        }
                        account_item_obj.account_id = array[k].id;
                        account_item_obj.account_name = array[k].display_name;
                        platform_account[platform_account.length] = account_item_obj
                    }
                }
                data.account = platform_account;
                // data.official_column = official_column;
                // data.par_official_column = par_official_column;
                data.site_id = site_id;
                if (website) {
                    data.classify_ai = websiteCheckedKeys;
                }
                let tdksobj = this.tdkList[0];
                data.title = tdksobj.title;
                data.keywords = tdksobj.keywords;
                data.desc = tdksobj.desc;
                // console.log(data)

                this.confrimSigleHandler(data)
            }
        },
        /* 确认生成单个视频 */
        confrimSigleHandler(data) {
            let oldTemplate = store.getters.get_template_rules();//获取原视频模板规则
            let replace_template = store.getters.get_back_template_rules();
            let query = window.location.href.split('?')[1]
            var videoId = undefined;
            if (query) {
                params = query.split('&');
                if (params.length == 1) {
                    let key = params[0].split('=')[0]
                    let value = params[0].split('=')[1]
                    if (key == 'id') {
                        videoId = value - 0;
                    }
                } else if (params.length > 1) {
                    let obj = {};
                    for (let i = 0; i < params.length; i++) {
                        let k = params[i].split('=')[0]
                        let v = params[i].split('=')[1]
                        obj[k] = v;
                    }
                    let id = obj.id;
                    if (id) {
                        videoId = id - 0;
                    }
                }
            }
            let oldRule = oldTemplate;
            if (videoId) {
                oldRule = replace_template;
            }
            let newRule = data.rule;
            let had_not_replace = false;
            for (let i = 0; i < oldRule.length; i++) {//遍历视频 模板规则
                let oldItem = oldRule[i];
                let newItem = newRule[i];
                if (oldItem && newItem) {
                    let oldImgRule = oldItem.imgrule;
                    let newImgRule = newItem.imgrule;
                    let oldTitleRule = oldItem.titleRule;
                    let newTitleRule = newItem.titleRule;
                    if (oldImgRule && newImgRule) {//是否有素材规则
                        for (let j = 0; j < oldImgRule.length; j++) {//遍历片段 素材规则
                            let oldImgItem = oldImgRule[j];//素材
                            let newImgItem = newImgRule[j];
                            had_not_replace = had_not_replace || oldImgItem.test == newImgItem.img.file;//如果备份模板规则内素材路径与新路径一致，则未替换
                        }
                    }
                    if (oldTitleRule && newTitleRule) {
                        for (let k = 0; k < oldTitleRule.length; k++) {
                            let oldTitleItem = oldTitleRule[k];//文案
                            let newTitleItem = newTitleRule[k];//文案
                            for (let l = 0; l < oldTitleItem.length; l++) {
                                let oldTextList = oldTitleItem[l].test;
                                let newTextList = newTitleItem[l].title;
                                for (let q = 0; q < oldTextList.length; q++) {
                                    had_not_replace = had_not_replace || oldTextList[q] == newTextList[q];
                                }
                            }
                        }
                    }
                }

            }
            my_self_logs('生成视频参数===', data)
            my_self_logs('是否有未替换文案', had_not_replace);
            // console.log('原视频模板规则',oldTemplate);

            if (had_not_replace) {//如果有未替换素材
                this.$confirm('有素材未替换，是否用原素材？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async () => {
                    this.createVideo(data);
                    return
                }).catch(() => {
                    this.isLoading = false;
                    this.$message({
                        showClose: true,
                        type: 'info',
                        message: '已取消生成!',
                        duration: 3000,
                        offset: 100
                    });
                })
                return;
            }

            this.createVideo(data);
        },
        /* 单个视频生成请求 */
        async createVideo(data) {
            let self = this;
            window.loading = self.$loading({
                lock: true,
                text: '视频创建中，请稍等',
                spinner: 'el-icon-loading',
                background: 'rgba(0,0,0,0.4)'
            });
            var token = get_cookie_token();
            $.ajax({
                url: my_video_request_api.create_single_video,
                type: "POST",
                dataType: 'json',
                data: JSON.stringify(data),
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token,
                },
                success: function (res) {
                    my_self_logs('创建视频请求', res);
                    if (res.status == 1) {
                        let query = window.location.href.split('?')[1]
                        var videoId = undefined;
                        if (query) {
                            params = query.split('&');
                            if (params.length == 1) {
                                let key = params[0].split('=')[0]
                                let value = params[0].split('=')[1]
                                if (key == 'id') {
                                    videoId = value - 0;
                                }
                            } else if (params.length > 1) {
                                let obj = {};
                                for (let i = 0; i < params.length; i++) {
                                    let k = params[i].split('=')[0]
                                    let v = params[i].split('=')[1]
                                    obj[k] = v;
                                }
                                let id = obj.id;
                                if (id) {
                                    videoId = id - 0;
                                }
                            }
                        }
                        let message = '视频创建成功！';
                        if (videoId) {
                            message = '视频编辑成功！';
                        }
                        my_self_logs('单个视频编辑创建===', res)
                        if (window.loading) {
                            window.loading.close();
                            window.loading = null;
                        }
                        self.$message({
                            message: message,
                            type: 'success',
                            showClose: true,
                            duration: 3000,
                            offset: 100
                        })
                        setTimeout(() => {
                            self.closeDialog();
                            window.location.href = '/lists';
                        }, 1500)
                    } else {
                        self.closeDialog();
                        self.$message({
                            message: res.msg,
                            type: 'error',
                            showClose: true,
                            duration: 3000,
                            offset: 100
                        })
                    }
                },
                error: function (err) {
                    my_self_logs('创建失败', err);
                    // console.log('创建失败',err);

                    if (window.loading) {
                        window.loading.close();
                        window.loading = null;
                    }
                    self.isLoading = false;
                    self.$message({
                        message: '服务器出错了',
                        type: 'error',
                        showClose: true,
                        duration: 3000,
                        offset: 100
                    })
                }
            })
        },
        /* 社媒tabs事件 */
        activeHandler(release, index) {
            console.log('哪里')
            this.releaseHanlder(this.current_release_index !== index || !release.isChecked, index);

            this.current_release_index = index;
            this.accounts.forEach((item, idx) => {
                if (idx == index) {
                    return;
                }
                this.$set(this.accounts[idx], 'jujiao_isShow', true)
            })
        },
        /* 社媒平台选择 */
        releaseHanlder(e, index) {
            console.log(e,index,'社媒平台选择')
            // console.log(store.getters.get_official_account())
            let allList = store.getters.get_official_account();
            // console.log(allList)
            allList.map((m, n) => {
                if (m.media_type == this.accounts[index].media && m.last_select_industry_id != 0) {
                    this.$set(this.accounts[index], 'industry_id', m.last_select_industry_id)
                    this.$set(this.accounts[index], 'jujiao_isChecked', true)
                }
            })
            // console.log('社媒平台选择',e,index,this.accounts)
            this.$set(this.accounts[index], 'isChecked', e);
            var account = this.accounts[index].account; //绑定账号

            this.current_release_index = index;
            if (!e) {//取消选中
                for (let i = 0; i < account.length; i++) {
                    this.$set(this.accounts[index].account[i], 'isChecked', false)
                    // console.log(this.accounts[index].account[i])
                }
                this.$set(this.accounts[index], 'industry_id', undefined)
                this.$set(this.accounts[index], 'jujiao_isChecked', false)
                let allNotChecked = false;
                for (let k = 0; k < this.accounts.length; k++) {
                    if (k == index) {
                        continue;
                    }
                    allNotChecked = allNotChecked || this.accounts[k].isChecked//除自身外 还有有一个平台选中则为true
                }
                for (let j = 0; j < this.accounts[index].jujiao_account.length; j++) {
                    // console.log(this.accounts[index].jujiao_account[j]);
                    this.$set(this.accounts[index].jujiao_account[j], 'isChecked', false)
                }
                if (!allNotChecked) {//没有选中任何平台
                    this.release = false;
                }
            } else {
                this.release = true;
                let shouldCheck =  account.every(t => !t.isChecked);
                for (let j = 0; j < account.length; j++) {
                    const ac = account[j];
                    if (account[j].disabled || account[j].status != 1 || this.account_disabled(account[j].id)) {
                        this.$set(ac, 'isChecked', false)
                    } else if (shouldCheck) {
                        this.$set(this.accounts[index].account[j], 'isChecked', true)
                    }
                }

            }
            // 判断社媒是否全部选中
            let length = 0
            let showLength = 0
            for (let index = 0; index < this.accounts.length; index++) {
                if (this.accounts[index].isChecked) {
                    length++
                }
                if (this.accounts[index].account.length > 0 || this.accounts[index].jujiao_account.length > 0) {
                    showLength++
                }
            }
            if (length > 0 && length < showLength) {
                this.isMediaIndeterminate = true
            } else {
                this.isMediaIndeterminate = false
            }
            if (length == showLength) {
                this.isCheckedAllMedia = true
            } else {
                this.isCheckedAllMedia = false
            }

            var _t = this;
            // _t.checkChooseOrNo();
            _t.debounce(() => {
                _t.chooseNewShareVideoTTs()
            }, 800)();
        },
        async getNewShareVideoLanguage(){
            this.isLoadingTdk = true;
            var data = {
                id:this.sharedialog_video_id
            }
            if(this.GetQueryString('parentid')){
                data.ttsVideo=1;
            }
            console.log(data,'data')
            let res = await my_http_ajax('/api/video/tts-oauth-default','get',data,this);
            this.isLoadingTdk = false;
            this.new_video_tts_interface = res.data;
            console.log(this.new_video_tts_interface,'this.new_video_tts_interface')
            this.share_video_tts_id = [];
            // 在这里改默认选择的语种
            // this.share_video_tts_id.push(res.data[0].id);
            if (res.data.length > 1) {
                this.share_video_tts_id.push(res.data[1].id);
            } else {
                this.share_video_tts_id.push(res.data[0].id);
            }

            this.share_video_tts_id_language = res.data.reduce((a,b)=>{
                if(b.oauth.length>0){
                    a.push(b.id)
                }
                return a;
            },[]);
            this.chooseNewShareVideoTTs();
        },
        chooseNewShareVideoTTsFun(){
            var _t = this;
            _t.debounce(() => {
                _t.chooseNewShareVideoTTs()
            }, 800)();
            _t.clickBody();
        },
        async chooseNewShareVideoTTs(){
            var _t =this;
            var chooselist = [];
            var choose = _t.accounts.reduce((b,a)=>{
                if(a.account){
                    if(a.isChecked){
                        chooselist.push(a)
                    }
                    a.account.forEach(c=>{
                        if(c.isChecked){
                            b.push(c.id)
                        }
                    })
                }
                return b;
            },[])
            _t.chooseCheckItem = chooselist;
            _t.new_share_video_tts_Loading = true;
            var data = {
                id:this.sharedialog_video_id,
                tts_id:_t.share_video_tts_id.length>0?_t.share_video_tts_id:0,
                oauth_id:choose.length>0?choose:0
            }
            let res = await my_http_ajax('/api/video/tts-oauth-checkout','post',data,this);
            _t.new_share_video_tts_Loading = false;
            res.data.forEach(a=>{
                a.ids = a.oauth.reduce((c,d)=>{
                    c.push(d.id)
                    return c;
                },[])
            })
            _t.newnewVideoTTs = res.data;
        },
        languagePopoverClick(e){
            var _t =this;
            console.log(e,'e')
            e.oauth = e.allOauth.filter((a)=>{
                return e.ids.indexOf(a.id)>-1;
            })
            // 筛选全部需要的选择
            var newIds = [];
            _t.newnewVideoTTs.forEach(a=>{
                newIds.push(...a.ids);
            })
            // 筛选
            _t.accounts.filter((a,i)=>{
                e.allOauth.filter((t)=>{
                    if(newIds.indexOf(t.id)==-1){
                        if(a.media == t.media){
                            a.account.forEach((k,j)=>{
                                if(t.id==k.id){
                                    _t.$set(this.accounts[i].account[j], 'isChecked', false);
                                    // _t.accountHandler(false,j,i)
                                }
                            })
                        };
                    }else{
                        if(a.media == t.media){
                            a.account.forEach((k,j)=>{
                                if(t.id==k.id){
                                    _t.$set(this.accounts[i].account[j], 'isChecked', true);
                                    // _t.accountHandler(true,j,i)
                                }
                            })
                        };
                    }
                })
            })
            _t.$forceUpdate();
        },
        languageChooseFun(e,i){
            var _t = this;
        },
        async clickChangeLanguage(e){
            var item = this.newnewVideoTTs.filter(a=>{
                return a.languageName == e;
            })
            var name = item[0].language;
            var language =  name.split('-')[0];
            var data = {
                content:[
                    this.tdkList[0].title,
                    this.tdkList[0].keywords,
                    this.tdkList[0].desc
                ],
                from: "en",
                to: language
            }
            if(!this.checkIdentical()){
                console.log('true')
                return;
            }
            if(!data.content.some(a=>{
                if(a==''){
                    return false;
                }
                return true
            })){
                this.$message({
                    showClose: true,
                    message: 'TDK不能为空',
                    type: 'warning',
                    duration: 3000,
                    offset: 100
                });
            }
            this.showChangeLanguageLoading = true;
            let res = await my_http_ajax('/api/translate','post',data,this);
            if(res.status==1){
                this.newTdk.forEach(a=>{
                    console.log(a)
                    if(a.name==this.languageTransLates){
                        a.title  = res.data.content[0];
                        a.keywords = res.data.content[1];
                        a.desc = res.data.content[2];
                        a.translate = true;
                    }
                })
            }
            this.showChangeLanguageLoading = false;
        },
        changeLanguageData(){
            var _t =this;
            let newArray = this.newnewVideoTTs.reduce((a,b)=>{
                a.push({
                    id:b.id,
                    language:b.language?b.language:'默认视频',
                    name:b.languageName,
                    title:_t.tdkList[0].title,
                    keywords:_t.tdkList[0].keywords,
                    desc:_t.tdkList[0].desc
                })
                return a;
            },[])
            this.newTdk = newArray;
            console.log(this.newTdk,'this.newTdk')
        },
        async showChangeLanguage(){
            let newArray = this.newnewVideoTTs.reduce((a,b)=>{
                if(b.id!=""){
                    a.push(b)
                }
                return a;
            },[])
            if(newArray.length==0){
                return;
            }
            var name = newArray[0].language;
            var language =  name.split('-')[0];
            this.languageTransLates = newArray[0].languageName;
            var data = {
                content:[
                    this.tdkList[0].title,
                    this.tdkList[0].keywords,
                    this.tdkList[0].desc
                ],
                from: "en",
                to: language
            }
            if(!data.content.some(a=>{
                if(a==''){
                    return false;
                }
                return true
            })){
                this.$message({
                    showClose: true,
                    message: 'TDK不能为空',
                    type: 'warning',
                    duration: 3000,
                    offset: 100
                });
            }
            this.showChangeLanguageLoading = true;
            let res = await my_http_ajax('/api/translate','post',data,this);
            console.log(this.newTdk,this.languageTransLates)
            if(res.status==1){
                this.newTdk.forEach(a=>{
                    if(a.name==this.languageTransLates){
                        a.title  = res.data.content[0];
                        a.keywords = res.data.content[1];
                        a.desc = res.data.content[2];
                        a.translate = true;
                    }
                })
            }
            this.showChangeLanguageLoading = false;
            console.log(res);
        },
        /* 账号选中事件 */
        accountHandler(e, i) {
            var _t = this;
            console.log('账号勾选更改监听', e, i,this.current_release_index)
            if (e) {//选中
                let youtubeAccount = this.accounts[1].account;
                let youtubeChecked = false;
                for (let i = 0; i < youtubeAccount.length; i++) {
                    youtubeChecked = youtubeChecked || youtubeAccount[i].isChecked
                }
                this.release = true;
                this.$set(this.accounts[this.current_release_index].account[i], 'isChecked', e);//勾选账号
                this.$set(this.accounts[this.current_release_index], 'isChecked', true)//勾选平台
            } else {//取消
                var account = this.accounts[this.current_release_index].account;
                var hasAccount = false;//是否至少有一个勾选
                for (var i = 0; i < account.length; i++) {
                    hasAccount = hasAccount || account[i].isChecked
                }
                let hasJujiaoAccount = this.accounts[this.current_release_index].official_account_id
                if (!hasAccount && !hasJujiaoAccount) {//无选中任何账号
                    // console.log(this.accounts[this.current_release_index].jujiao_isChecked)
                    if (this.accounts[this.current_release_index].jujiao_isChecked == false) {
                        this.$set(this.accounts[this.current_release_index], 'isChecked', false)//所有未选，取消勾选平台
                        let hasRelease = false;//是否只是有一个平台勾选
                        for (let c = 0; c < this.accounts.length; c++) {
                            hasRelease = hasRelease || this.accounts[c].isChecked
                        }
                        if (!hasRelease) {
                            this.release = false;
                        }
                    }

                }
            }
            _t.debounce(() => {
                _t.chooseNewShareVideoTTs();
            }, 800)();
            // _t.checkChooseOrNo();
        },

         /* 分享到小渔夫 */
         async share_video_to_fish(data) {
            if (this.ishare_material != 'material') {
                this.$set(data.data[0], 'classify', 1)
            }

            if (this.website && this.gifUrl) {
                data.preview_gif = await Promise.resolve($.ajax({
                    method: 'POST',
                    url: '/api/get-sign-material',
                    headers: {
                        Authorization: get_cookie_token(),
                        'Content-Type': 'applicatin/json'
                    },
                    data: JSON.stringify({ filename: 'temp.gif' })
                })).then(res => {
                    var data = res.data;
                    var blob = this.gifBlob;
                    let signObj = {
                        name: 'temp.gif',
                        key: data.object_name,
                        policy: data.policy,
                        OSSAccessKeyId: data.accessid,
                        success_action_status: '200',
                        signature: data.signature
                    };
                    let formdata = new FormData();
                    for (let key in signObj) {
                        formdata.append(key, signObj[key]);
                    }
                    blob.name = 'temp.gif';
                    formdata.append('file', blob);

                    return new Promise(resolve => {
                        var xhr = new XMLHttpRequest();
                        xhr.onload = function () {
                            resolve(data.host + data.object_name);
                        };
                        xhr.open('POST', data.host);
                        xhr.send(formdata);
                    });
                });
            }

            let self = this;
            let res = await my_http_ajax(my_video_request_api.share_video_to_fish, "POST", {
                reptile_list_id: data.data[0].id,
                media: data.data[0].media,
                site_ids: data.site_id,
                title:	data.data[0].title,
                keywords:	data.data[0].keywords,
                desc:	data.data[0].desc,
            }, self);
            self.isLoading = false;
            if (res) {
                my_self_logs('分享成功', res)
                store.mutations.set_shareTimeType(self.shareTimeType)
                self.closeDialog();
                self.$message({
                    showClose: true,
                    message: '提交成功！视频正在分享中，请稍后查看分享结果!',
                    type: 'success',
                    duration: 3000,
                    offset: 100
                })
                let params;
                if (this.ishare_material == 'material') {
                    params = localStorage.getItem('material_data');
                } else {
                    params = store.getters.get_video_list_params();
                }
                self.$emit('refresh', params);//刷新列表数据
            }
        },
        /* 分享请求 */
        async share_video_request(data) {
            if (this.ishare_material != 'material') {
                this.$set(data.data[0], 'classify', 1)
            }

            if (this.website && this.gifUrl) {
                data.preview_gif = await Promise.resolve($.ajax({
                    method: 'POST',
                    url: '/api/get-sign-material',
                    headers: {
                        Authorization: get_cookie_token(),
                        'Content-Type': 'applicatin/json'
                    },
                    data: JSON.stringify({ filename: 'temp.gif' })
                })).then(res => {
                    var data = res.data;
                    var blob = this.gifBlob;
                    let signObj = {
                        name: 'temp.gif',
                        key: data.object_name,
                        policy: data.policy,
                        OSSAccessKeyId: data.accessid,
                        success_action_status: '200',
                        signature: data.signature
                    };
                    let formdata = new FormData();
                    for (let key in signObj) {
                        formdata.append(key, signObj[key]);
                    }
                    blob.name = 'temp.gif';
                    formdata.append('file', blob);

                    return new Promise(resolve => {
                        var xhr = new XMLHttpRequest();
                        xhr.onload = function () {
                            resolve(data.host + data.object_name);
                        };
                        xhr.open('POST', data.host);
                        xhr.send(formdata);
                    });
                });
            }

            var params = data;
            let self = this;
            let res = await my_http_ajax(my_video_request_api.share_video, "POST", params, self);
            self.isLoading = false;
            if (res) {
                my_self_logs('分享成功', res)
                store.mutations.set_shareTimeType(self.shareTimeType)
                self.closeDialog();
                self.$message({
                    showClose: true,
                    message: '提交成功！视频正在分享中，请稍后查看分享结果!',
                    type: 'success',
                    duration: 3000,
                    offset: 100
                })
                let params;
                if (this.ishare_material == 'material') {
                    params = localStorage.getItem('material_data');
                } else {
                    params = store.getters.get_video_list_params();
                }
                self.$emit('refresh', params);//刷新列表数据
            }
        },
        /* 分享到视频官网资源库的分享请求 */
        async share_video_to_website_resource_library_request(id) {
            console.log('分享到视频官网资源库的分享请求 id', id)
            let tts_video_share_type
            if (this.share_video_tts_types.length) {
                tts_video_share_type = this.shareTtsType;
            } else if (this.params[0] && this.params[0].tts_id) {
                tts_video_share_type = 3;
            }
            let res = await my_http_ajax(my_video_request_api.share_video_website_resource_library, "POST", { id, tts_video_share_type }, this);
            this.isLoading = false;
            if (res) {
                if (res.status == 1) {
                    my_self_logs('分享成功', res)
                    this.closeDialog();
                    this.$message({
                        showClose: true,
                        message: '提交成功！视频正在分享中，请稍后查看分享结果!',
                        type: 'success',
                        duration: 3000,
                        offset: 100
                    })
                    let params = store.getters.get_video_list_params();
                    // console.log(params)
                    this.$emit('refresh', params);//刷新列表数据
                } else {
                    this.$message({
                        showClose: true,
                        message: '分享失败!',
                        type: 'success',
                        duration: 3000,
                        offset: 100
                    })
                }
            }
        },
        /* 确认生成事件 */
        confrimCreate(platform, account) {
            let site_list = store.getters.get_site_list();
            // let fish_site_list = store.getters.get_fish_site_list();
            let products = this.params;
            // console.log(platform,account);
            let params = [];
            for (let j = 0; j < site_list.length; j++) {
                let site = site_list[j]
                params[j] = {
                    site_id: site.site_id,
                    site_name: site.url,
                    platform,
                    data: [],
                    account: account
                }
                for (let k = 0; k < products.length; k++) {
                    let product = products[k];
                    if (product.site_id == site.site_id) {
                        let video_template_list = store.getters.get_checked_template_list();//选中模板列表
                        let len = params[j].data.length;//产品数量
                        let max = video_template_list.length;//选中模板数量
                        let index = 0;
                        if (max == 0) {
                            index = 0;
                            let template_index = store.getters.get_template_list().length;
                            if (template_index == 0) {
                                this.$message({
                                    showClose: true,
                                    message: '当前暂无可用的视频模板',
                                    type: 'warning',
                                    duration: 3000,
                                    offset: 100
                                })
                                return;
                            }
                            product.temlist_id = store.getters.get_template_list()[index].id;
                            product.temlist_name = store.getters.get_template_list()[index].name;
                        } else {
                            index = loop_index(len, max, 1);
                            // console.log('最终下标',index)
                            product.temlist_id = video_template_list[index].id;
                            product.temlist_name = video_template_list[index].name;
                        }
                        params[j].data.push(product)
                    }
                }
            }
            my_self_logs('生成参数===', params)
            this.create_video_request(params);
        },
        /* 生成请求 */
        async create_video_request(params) {
            let self = this;
            let res = await my_http_ajax(my_video_request_api.create, "POST", { video: params }, self);
            self.isLoading = false;
            if (res) {
                my_self_logs('生成视频请求成功', res)
                self.closeDialog()
                self.$message({
                    showClose: true,
                    type: 'success',
                    message: '生成成功！',
                    duration: 3000,
                    offset: 100
                })
                window.location.href = '/lists'
            }
        },
        // 复制链接
        cloneUrl(url) {
            var _input = document.createElement("input");   // 直接构建input
            _input.value = url;  // 设置内容
            document.body.appendChild(_input);    // 添加临时实例
            _input.select();   // 选择实例内容
            document.execCommand("Copy");   // 执行复制
            this.$message({
                message: '视频链接复制成功！',
                type: 'success',
                duration: '2000'
            });
            document.body.removeChild(_input);
        },
        // 第一页切换
        async waynextStep(index) {
            if (this.activeWebsiteIndexTab != 'websitePageTab') {
                this.activeWebsiteIndexTab = 'websitePageTab'
                //初始化 切换到 视频分享到视频官网页面
                this.hasWebsite = true;
                this.website = false;

                //清空 视频分享到视频官网资源库的数据
                this.isActiveWebsiteResourceLibrary = false;
                this.website_resource_library = false;
            }
            // this.shareTimeType = store.getters.get_shareTimeType();
            if (index == 1) {
                console.log(this.siteList)
                if (this.userMeal[10].lower[32].value == 2) {
                    showMealWarn(this.$parent.$refs.tipsDialog, 'mealAuth', 'notFuntion');
                    return;
                }
                // console.log(this.isShow_cms_option)
                if (this.isShow_cms_option || this.siteList.length > 0) {
                    this.contentClone = false;
                    this.firstStep = false;
                    this.optionType = 3;
                } else {
                    this.$message({
                        message: '视频分享到全网通，请先进行账号授权！',
                        type: 'error',
                        duration: '2000'
                    });
                }

            } else if (index == 2) {
                if (this.userMeal[10].lower[30].value == 2) {
                    showMealWarn(this.$parent.$refs.tipsDialog, 'mealAuth', 'notFuntion');
                    return;
                }
                if (this.hasWebsite || this.isActiveWebsiteResourceLibrary) {
                    this.contentClone = false;
                    this.firstStep = false;
                    this.optionType = 2;
                } else {
                    this.$message({
                        message: '您尚未开通视频官网，开通请联系客服：020-22818315',
                        type: 'error',
                        duration: '2000'
                    });
                }

            } else if (index == 3) {
              console.log('new_video_tts_interface', this.new_video_tts_interface)
                if(this.isFishNewUser) {
                  if (this.params[0]?.ttsVideo?.length > 0) {
                    this.firstStep = false;
                    this.optionType = 33
                    this.contentClone = false
                    return
                  }
                    const env = await this.getFishEnv()
                    if (env && this.params[0]) {
                        const url = `${env.domain}/social-media/release/video-sharing?auth_code=${env.auth_code}&client_id=${env.tenant_account_id}`
                        // const url = `http://social.dweyes.cn/social-media/release/video-sharing?auth_code=${env.auth_code}&client_id=${env.tenant_account_id}`
                        var videoUrl = encodeURIComponent(this.wurl || this.surl)
                        var thumbnail = ''
                        if(this.params[0]){
                            thumbnail = encodeURIComponent(this.params[0].thumbnail)
                        }
                        console.log(`${url}&videourl=${videoUrl}&thumbnail=${thumbnail}`)
                        var a = document.createElement('a');
                        a.setAttribute('href', `${url}&videourl=${videoUrl}&thumbnail=${thumbnail}`);
                        a.setAttribute('target', '_blank');
                        a.click();
                    }else{
                        this.$message({
                            message: '分享失败',
                            type: 'error',
                            duration: '2000'
                        });
                    }
                }else{
                    if (this.socialMediaWithoutPerm) {
                        showMealWarn(this.$parent.$refs.tipsDialog, 'mealAuth', 'notFuntion');
                        return;
                    }
                    this.checkedAllMedia(true)
                    this.contentClone = false;
                    this.firstStep = false;
                    this.optionType = 1;
                    this.getNewShareVideoLanguage();
                    this.$nextTick(() => {
                        if (this.$refs.radioGroup) {
                            console.log(this.$refs.radioGroup.$el.scrollHeight);
                            this.languageCollapsed = this.$refs.radioGroup.$el.scrollHeight > 44;
                        } else {
                            this.languageCollapsible = false;
                            this.languageCollapsed = false;
                        }
                    });
                }
            } else if (index == 4) {//小渔夫代理商
                console.log('this.fishSiteList', this.fishSiteList);
                if (this.userMeal[10].lower[31].value != 1) {
                    showMealWarn(this.$parent.$refs.tipsDialog, 'mealAuth', 'notFuntion');
                    return;
                }
                if (this.fishSiteList.length > 0) {
                    this.contentClone = false;
                    this.firstStep = false;
                    this.optionType = 4;

                    if (this.shareTtsType === 1) {
                        this.shareTtsType = 2;
                    }
                } else {
                    if (this.fishSiteListLoading) {
                        this.$message({
                            message: '小渔夫站点列表加载中，请稍后再试！',
                            type: 'error',
                            duration: '2000'
                        });
                    } else {
                        this.$message({
                            message: '视频分享到小渔夫，请先授权开通小渔夫产品并创建网站！',
                            type: 'error',
                            duration: '2000'
                        });
                    }
                }
            } else if (index == 5) { // video2b
                if (this.userMeal[10].lower[49] && this.userMeal[10].lower[49].value != 1) {
                    showMealWarn(this.$parent.$refs.tipsDialog, 'mealAuth', 'notFuntion');
                    return;
                }
                if (this.hasVideo2bAccount) {
                    this.contentClone = false;
                    this.firstStep = false;
                    this.optionType = 5;
                    if (!this.video2bSiteList.length) {
                        this.getVideo2bSiteLists();
                    }
                } else {
                    this.$message({
                        message: '视频分享到Video2B，请先进行账号授权！',
                        type: 'error',
                        duration: '2000'
                    });
                }
            }
        },
        //去授权页面
        toAuthorizePage() {
            store.mutations.set_mediaTab('mediaAccountTab');
            window.location.href = '/setting?nav=2';
        },
        get_account_name(account) {
            console.log(account)
            let name = account.display_name || account.account
            if (account.media == 5) {
                if (account.type == 3) {
                    name += '(个人)'
                } else if (account.type == 4) {
                    name += '(公司)'
                }
            }
            return name
        },
        /* 获取分享建议时间 */
        async get_share_times() {
            let res = await my_http_ajax(my_video_request_api.share_times, "GET", {}, this);
            if (res) {
                this.shareTimeList = res.data
            }
        },
        checkedAllMedia(bol) {
            let list = this.accounts
            for (let index = list.length - 1; index >= 0; index--) {
                if ((list[index].account.length > 0 || list[index].jujiao_account.length > 0) && !list[index].disabled) {
                    this.releaseHanlder(bol, index)
                }
            }
        },
        // 全选社媒
        changeCheckedAllMedia() {
            if (this.isCheckedAllMedia) {
                this.checkedAllMedia(true)
            } else {
                this.checkedAllMedia(false)
            }
            // this.checkChooseOrNo();
            this.debounce(() => {
                this.chooseNewShareVideoTTs()
            }, 800)();
        },
        // 设置多语种视频分享选项
        setTtsTypes() {
            if (this.hasTranslate == 'yes') {
                this.share_video_tts_types = [{
                    label: 1,
                    text: '按同语种相应分享',
                    compare: 2
                }, {
                    label: 2,
                    text: this.activeWebsiteIndexTab == 'websiteResourceLibraryTab' ? '仅英语字幕视频' : '全部使用英语字幕',
                    compare: 1
                }, {
                    label: 0,
                    text: this.activeWebsiteIndexTab == 'websiteResourceLibraryTab' ? '默认视频(无字幕)' : '使用默认视频(无字幕)',
                    compare: 0
                }]
            } else if (this.hasTranslate == 'no') {
                this.share_video_tts_types = [{
                    label: 2,
                    text: '使用字幕视频',
                    compare: 1
                }, {
                    label: 0,
                    text: '使用默认视频(无字幕)',
                    compare: 0
                }]
            }
        },
        // 计算关键词长度，YouTube的关键词字符数计算规则：关键词组之间的第一个空格，算3个字符
        keywordsLength(str) {
            if(!str){
                return 0
            }
            if (this.tdkKeywordRule.media == 'YouTube') {
                let keywordArr = str.split(',')
                let length = 0
                for (let index = 0; index < keywordArr.length; index++) {
                    let keyword = keywordArr[index].replace(/(^\s*)|(\s*$)/g, "")
                    let keywordLeng = keyword.split(' ')
                    if (keywordLeng.length > 1) {
                        length += keyword.length + 2
                    } else {
                        length += keyword.length
                    }
                }
                // 关键词组大于一个，需加上逗号的长度
                if (keywordArr.length > 1) {
                    length += keywordArr.length - 1
                }
                return length
            } else {
                return str.length
            }
        },
        handleMetadataLoaded(e) {
            this.totalDuration = e.target.duration;
            this.cropperLoading = false;
        },
        formatDuration(value) {
            const totalValue = value * 1e3;
            const roundedValue = Math.round(totalValue / 10) * 10;
            const milliseconds = roundedValue % 1e3;
            let seconds = Math.floor(roundedValue / 1e3);
            let minutes = Math.floor(seconds / 60);
            seconds %= 60;

            return [
                ('0' + minutes).slice(-2),
                ('0' + seconds).slice(-2)
            ].join(':') + '.' + ('00' + milliseconds).slice(-3, -1);
        },
        handleMouseDown(e) {
            if (this.playing) {
                return;
            }
            this.cropping = true;

            this.origPos = e.clientX;
            this.origStart = this.cropPos;
            document.body.classList.add('unselectable');

            document.addEventListener('mousemove', this.handleMouseMove);
            document.addEventListener('mouseup', this.handleMouseUp);
        },
        handleMouseMove(e) {
            console.log('handleMouseMove');
            if (this.cropping) {
                const delta = (e.clientX - this.origPos) / 678 * this.totalDuration;
                this.cropPos = Math.max(Math.min(this.origStart + delta, this.totalDuration - 3), 0);
            }
        },
        handleMouseUp() {
            if (this.cropping) {
                this.cropping = false;
                this.$nextTick(() => {
                    document.body.classList.remove('unselectable');
                });

                document.removeEventListener('mousemove', this.handleMouseMove);
                document.removeEventListener('mouseup', this.handleMouseUp);
            }
        },
        handleCurrent(e) {
            if (this.playing) {
                // var end = this.cropPos + 3;
                // if (this.prevCurrent <= end && e.target.currentTime >= end || e.target.currentTime >= this.totalDuration) {
                //     e.target.pause();
                //     setTimeout(() => {
                //         this.current = this.cropPos;
                //     }, 0);
                // } else {
                //     this.current = e.target.currentTime;
                // }
                this.current = e.target.currentTime;
            }
        },
        togglePlay() {
            if (this.playing) {
                this.$refs.cropVideo.pause();
            } else {
                this.prevCurrent = this.current;
                this.$refs.cropVideo.play();
            }
        },
        handlePlay() {
            this.playing = true;
            this.$emit('play');
        },
        handlePause() {
            this.playing = false;
            this.$emit('pause');
        },
        enterVideoCrop() {
            this.cropperShowing = true;
            if (!this.totalDuration) {
                this.cropperLoading = true;
            } else if (this.current !== this.cropPos) {
                this.current = this.cropPos;
            } else {
                this.$nextTick(() => {
                    this.$refs.cropVideo.currentTime = this.current;
                });
            }
        },
        handleVideoCrop() {
            this.cropperLoading = true;
            new Promise((resolve, reject) => {
                var video = document.createElement('video');
                video.crossOrigin = 'anonymous';
                video.muted = true;
                video.style.display = 'none';
                document.body.appendChild(video);
                var that = this;

                function f() {
                    video.removeEventListener('canplay', f);
                    var height = video.videoHeight;
                    var obj = new GIF({
                        workerScript: '/js/gif.worker.js',
                        width: video.videoWidth,
                        height,
                        workers: 18
                    });

                    var updateTimer;

                    obj.on('finished', blob => {
                        that.gifBlob = blob;
                        that.gifUrl = URL.createObjectURL(blob);

                        resolve();
                    });

                    video.play();

                    var current = video.currentTime;

                    function updateFrame() {
                        var next = video.currentTime;

                        var canvas = document.createElement('canvas');
                        canvas.width = video.videoWidth;
                        canvas.height = height;
                        var context = canvas.getContext('2d');

                        context.drawImage(video, 0, 0);

                        if (next !== current) {
                            obj.addFrame(canvas, {
                                delay: (next - current) * 1e3 // milliseconds
                            });
                        }

                        return next;
                    }

                    function renderGif() {
                        clearTimeout(updateTimer);
                        setTimeout(() => {
                            obj.render();
                        }, 50);
                    }

                    function update() {
                        var next = updateFrame();
                        current = next;

                        if (next > that.cropPos + 3) {
                            console.log('crop ended');
                            renderGif();
                            video.onended = null;
                            video.pause();
                            return;
                        }
                        updateTimer = setTimeout(update, 100);
                    }

                    video.onended = function () {
                        console.log('video ended');
                        console.log(obj);
                        updateFrame();
                        renderGif();
                    }

                    setTimeout(update, 180);
                }

                video.addEventListener('canplay', f);
                video.onerror = reject;
                video.src = this.wurl;
                video.currentTime = this.cropPos;
            }).then(() => {
                this.cropperShowing = false;
                this.cropperLoading = false;

                console.log(this.gifUrl);
            }, () => {
                this.cropperShowing = false;
                this.cropperLoading = false;
                this.$message({
                    message: '视频加载出现错误。',
                    type: 'warning'
                });
            });
        },
        removeCroppedGif() {
            if (this.gifUrl) {
                URL.revokeObjectURL(this.gifUrl);
                this.gifUrl = '';
            }
        },
        openWebsite() {
            window.open(this.currentWebsiteUrl, '_blank');
            this.closeDialog();
        },
        showPreview() {
            this.previewVisible = true;
            console.log(this.previewAccounts);
            this.previewingTab = this.previewAccounts[0].media;
        },
        toggleLanguageCollapse() {
            this.languageCollapsed = !this.languageCollapsed;
        },


        async getFishEnv(){
            let res = await my_http_ajax('/api/user/get-fish-tenant', "GET", {}, self);
            if(res.status === 1 && res.data){
                let codeRes = await my_http_ajax(
                    res.data.api_url + '/v2/tenant/passport/auth-code',
                    "post",
                    { account_id: res.data.tenant_account_id, tenant_id: res.data.tenant_id },
                    self,
                    false,
                    {appKey: res.data.key}
                );
                if (codeRes.code === 0) {
                    return {
                        ...res.data,
                        auth_code: codeRes.data
                    }
                }
            }
            return null
        }
    },
    computed: {
      hasYouTube () {
        const item = this.chooseCheckItem.find(i => i.media === 3)
        return !!item
      },
      showPrivacy() {
        const isTest = sessionStorage.getItem('isTest') === 'true'
        if(isTest && !this.firstStep && this.optionType === 1 && !this.isTDKstep && this.hasYouTube) {
          return true
        }
        return false
      },
      isOpenWebsite() {
        return this.userCounter?.is_open_website || false
      },
      chatBtnStatus(){
        return {
          title: this.titleChatGPTVisible,
          keyword: this.keywordsChatGPTVisible,
          desc: this.descChatGPTVisible,
        }
      },
      multilingualVideoList(){
        const list = []
        this.tts.forEach(tt =>{
          if (tt.country) {
            list.push(tt)
          }
        })
        return list
      },
      validationList() {
            var valid = [], invalid = [];
            var type = ['desc','title','keywords'];
            var _t = this;
            console.log(_t.tdkList)
            _t.accounts.forEach((ac) => {
                if (
                    (ac.account.length && ac.isChecked)
                    || (ac.jujiao_account.length && ac.jujiao_isChecked && ac.jujiao_isShow)
                ) {
                    var rules = ac.rules;
                    var typeRule = '';
                    if(rules.description){
                        rules.desc = rules.description;
                    }
                    Object.keys(rules).forEach(k=>{
                        if(type.indexOf(k)>-1){
                            typeRule =  rules[k];
                            _t.tdkList.forEach(a=>{
                                Object.keys(a).forEach(tdk=>{
                                    if(tdk == k){
                                        if (typeRule) {
                                            var limit = typeRule.limit;
                                            if (k=='title'&&!_t.keywordsLength(a[tdk])) {
                                                invalid.push(ac);
                                            } else if (!limit || limit >= _t.keywordsLength(a[tdk])) {
                                                valid.push(ac);
                                            } else {
                                                invalid.push(ac);
                                            }
                                        }
                                    }
                                })
                            })
                        }
                    })
                }
            });
            console.log(invalid)
            return {
                valid,
                invalid,
                total: valid.length + invalid.length
            };
        },
        has_new_video_tts(){
            var list = this.new_video_tts_interface.reduce((a,b)=>{
                if(b.language){
                    a.push(b)
                }
                return a;
            },[])
            if(list.length>0){
                return true;
            }
            return false;
        },
        dialogWidth() {
            if ((this.optionType == 1 || this.optionType == 2) && this.isTDKstep) {
                return 1100;
            }

            if (this.optionType == 1) {
                return 1046;
            }
            return 684;
        },
        account_list() {
            let index = this.current_release_index;
            let list = this.accounts;
            let release = list[index];
            if (release == undefined) return [];
            let account = release.account;
            return account;
        },
        account_status_label() {
            return function (status, account_id) {

                if (status === undefined || status == 1) {
                    var type = this.type;//弹框类型
                    if (type === 1) {//单个视频分享
                        var params = this.params;//视频列表
                        console.log(this.params)
                        let video = params[0]
                        let accounts = video ? video.account : '';//该视频分享的社媒账号列表
                        my_self_logs('该视频分享的社媒账号列表', accounts)
                        let isDisabled = false;
                        if (!accounts) return '';
                        for (let i = 0; i < accounts.length; i++) {//遍历社媒平台
                            let account = accounts[i].account;
                            if (account) {
                                for (let j = 0; j < account.length; j++) {//遍历该视频每个社媒下发布的账号
                                    if (account_id == account[j].account_id) {//传入的当前账号在发布账号中
                                        isDisabled = isDisabled || (account[j].status == 0 || account[j].status == undefined)//发布账号正在发布
                                        break;
                                    }
                                }
                            }
                        }
                        if (isDisabled) {
                            return '分享中';
                        }
                    }
                    return '';
                }
                switch (status) {
                    case 2:
                        return '(异常)';
                    case 3:
                        return '(过期)';
                    default:
                        return '';
                }
            }
        },
        /* 单个视频分享社媒状态判断 */
        account_disabled() {
            return function (account_id) {//传入社媒账号id
                // console.log(account_id)
                // console.log(this.type)
                var type = this.type;//弹框类型
                var params = this.params;//视频列表

                if (type === 1) {
                    console.log(params)
                    let video = params[0];
                    let accounts = video ? video.account : '';//该视频分享的社媒账号列表
                    my_self_logs('该视频分享的社媒账号列表', accounts)
                    let isDisabled = false;
                    if (!accounts) return false;
                    for (let i = 0; i < accounts.length; i++) {//遍历社媒平台
                        let account = accounts[i].account;
                        if (account) {
                            for (let j = 0; j < account.length; j++) {//遍历该视频每个社媒下发布的账号
                                if (account_id == account[j].account_id) {//传入的当前账号在发布账号中
                                    isDisabled = isDisabled || (account[j].status == 0 || account[j].status == undefined)//发布账号正在发布
                                    break;
                                }
                            }
                        }
                    }
                    return isDisabled;//isDisabled false
                }
                else {
                    return false
                }
            }
        },
        /* *
        *是否显示商品详情分享选项
        * */
        isShow_cms_option() {
            let type = this.type;
            if (type == 3) return false;//单个视频编辑不显示
            let params = this.params;
            if (type == 1) {
                let video = params[0];
                if (video) {
                    if (!video.site_id) {//单视频编辑生成的视频
                        return false;
                    } else {
                        return true;
                    }
                } else {
                    return true;
                }
            }
            if (type == 4) {
                let isAllSigleVideo = true;
                for (let i = 0; i < params.length; i++) {
                    let video = params[i];
                    isAllSigleVideo = isAllSigleVideo && (video.type == 2 || video.video_source_value == 3);//所有视频都是单视频生成
                }
                if (isAllSigleVideo) {
                    return false;
                } else {
                    return true;
                }
            }
        },
        showWarning() {
            let params = this.params;
            if (this.type == 4) {
                let isAllSigleVideo = true;
                let isAllMupVideo = true;
                for (let i = 0; i < params.length; i++) {
                    let video = params[i];
                    isAllSigleVideo = isAllSigleVideo && video.type == 2;//所有视频都是单视频生成
                    isAllMupVideo = isAllMupVideo && video.type == 3;
                }
                if (isAllSigleVideo || isAllMupVideo) {
                    return false;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        },
        hasSocialMedia() {
            var cur = this.userMeal && this.userMeal[10];
            if (cur) {
                // either social media or video2b
                return cur.lower[29].value != 3 || (cur.lower[49] && cur.lower[49].value != 3);
            }
            return false;
        },
        socialMediaWithoutPerm() {
            var cur = this.userMeal && this.userMeal[10];
            if (cur) {
                // neither social media nor video2b is permed
                return cur.lower[29].value > 1 && cur.lower[49] && cur.lower[49].value > 1;
            }
            return false;
        },
        liFisherActive() {
            return !!(this.userOrigin == 5 || this.userInfo && this.userInfo.origin_id);
        },
        trackStyle() {
            return {
                width: 300 / this.totalDuration + '%',
                left: this.cropPos * 100 / this.totalDuration + '%'
            }
        },
        useWebsiteNext() {
            return !this.legacy && this.ishare_material !== 'material' && !this.firstStep && this.optionType == 2 && this.shareTtsType !== 1 && this.activeWebsiteIndexTab === 'websitePageTab';
        },
        currentWebsiteUrl() {
            if (this.websiteUrl && this.useWebsiteNext && this.websiteNavigationIds && this.websiteNavigationIds.length) {
                return this.websiteUrl + '&jump=' + btoa(`/home/template/newly?type=aivideo&navigation_id=${encodeURIComponent(
                    this.websiteNavigationIds.map(id => {
                        var arr = id.split(',');
                        return arr[1] === '0' ? arr[0] : arr[1];
                    }).join(',')
                )}&aid=${this.sharedialog_video_id}${(this.share_video_tts_types.length && this.shareTtsType === 2 || this.parent) ? '&language=en-GB' : ''}`);
            }
            return '';
        },
        liFisherAllChecked: {
            get() {
                return this.checkFishSiteList && this.checkFishSiteList.length === this.fishSiteList.length;
            },
            set(value) {
                this.checkFishSiteList = value ? this.fishSiteList.map(t => t.id) : [];
            }
        },
        liFisherIndeterminate() {
            return this.checkFishSiteList && this.checkFishSiteList.length && this.checkFishSiteList.length < this.fishSiteList.length;
        },
        ttsLookup() {
            var ret = {};
            if (this.tts) {
                this.tts.forEach(tts => {
                    if (tts.id) {
                        ret[tts.id] = tts.url;
                    }
                });
            }
            return ret;
        },
        actualPreviewUrl() {
            console.log(this.ttsLookup);
            if (this.share_video_tts_id) {
                return this.ttsLookup[this.share_video_tts_id] || this.wurl;
            }
            return this.wurl;
        },
        isFishNewUser(){
            if(this.userMeal[10]){
                return !!this.userMeal[10].newFishUser
            }
            return false
        },
        fishSocialAccess(){
            return localStorage.getItem('social_access') === '1'
        }
    }
}
</script>
<style scoped>
    .swithBtn{
        position: absolute;
        right:66px;
        top:18px;
    }
    .tdk_tips{
        font-size: 12px;
        margin-bottom:9px;
        color:red;
    }
    .tak_poppver_box{
        margin-bottom:15px;
    }
    .tdk_poppver_Title{
        font-size: 14px;
        margin-top:6px;
        display:flex;
        align-items: center;
    }
    .tdk_poppver_Title img{
        width:20px;
        height:20px;
        margin-right:4px;
    }
    .tdk_poppver_proposal{
        font-size: 12px;
        margin-top:5px;
        padding-left:20px;
    }
    .tdk_box_tips{
        text-align: center;
        color:red;
        font-size: 12px;
    }
    .privacy-box {
      display: inline;
      float: right;
    }
</style>
